// import React, { useState, useRef, useEffect } from 'react';
// import {
//   AppBar,
//   Toolbar,
//   Typography,
//   IconButton,
//   Card,
//   CardContent,
//   Grid,
//   Box,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   LinearProgress,
//   Avatar,
//   List,
//   ListItem,
//   ListItemAvatar,
//   ListItemText,
//   Paper,
//   Drawer,
//   Container,
//   useTheme,
//   useMediaQuery,
//   Button,
//   Divider,
//   ListItemIcon,
//   CssBaseline,
//   createTheme,
//   ThemeProvider,
//   CircularProgress,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Chip,
//   Menu,
//   Slide,
//   Tooltip,
//   ClickAwayListener,
//   TextField,
//   Alert,
// } from '@mui/material';
// import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import dayjs from 'dayjs';
// import {
//   Menu as MenuIcon,
//   TrendingUp,
//   ShoppingCart,
//   AttachMoney,
//   ShowChart,
//   KeyboardArrowUp,
//   KeyboardArrowDown,
//   Dashboard as DashboardIcon,
//   Inventory,
//   Receipt,
//   People,
//   Analytics,
//   Download,
//   Close,
//   Sort,
//   SwapVert,
//   TrendingDown,
//   LocalShipping,
//   LocationOn,
//   SupervisorAccount,
//   AdminPanelSettings,
//   Store,
//   FileDownload,
// } from '@mui/icons-material';
// import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip as RechartsTooltip, ResponsiveContainer } from 'recharts';
// import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

// const theme = createTheme({
//   palette: {
//     primary: {
//       main: '#667eea',
//       light: '#a8b5f5',
//       dark: '#3d52a0',
//     },
//     secondary: {
//       main: '#f093fb',
//       light: '#f5b7fd',
//       dark: '#c86fc9',
//     },
//     background: {
//       default: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
//       paper: '#ffffff',
//     },
//     success: {
//       main: '#4ade80',
//       light: '#86efac',
//       dark: '#16a34a',
//     },
//     warning: {
//       main: '#fbbf24',
//       light: '#fcd34d',
//       dark: '#d97706',
//     },
//     info: {
//       main: '#3b82f6',
//       light: '#60a5fa',
//       dark: '#1d4ed8',
//     },
//     error: {
//       main: '#ef4444',
//       light: '#f87171',
//       dark: '#dc2626',
//     },
//   },
//   typography: {
//     fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
//     h4: {
//       fontSize: '2rem',
//       fontWeight: 700,
//       letterSpacing: '-0.02em',
//     },
//     h5: {
//       fontSize: '1.5rem',
//       fontWeight: 600,
//       letterSpacing: '-0.01em',
//     },
//     h6: {
//       fontSize: '1.125rem',
//       fontWeight: 600,
//       letterSpacing: '-0.01em',
//     },
//     body1: {
//       fontSize: '0.875rem',
//       lineHeight: 1.6,
//     },
//     body2: {
//       fontSize: '0.75rem',
//       lineHeight: 1.5,
//     },
//     caption: {
//       fontSize: '0.65rem',
//       fontWeight: 500,
//     },
//   },
//   shape: {
//     borderRadius: 16,
//   },
//   components: {
//     MuiCard: {
//       styleOverrides: {
//         root: {
//           borderRadius: 20,
//           background: 'rgba(255, 255, 255, 0.95)',
//           backdropFilter: 'blur(20px)',
//           border: '1px solid rgba(255, 255, 255, 0.2)',
//           boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
//           transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
//           '&:hover': {
//             transform: 'translateY(-8px)',
//             boxShadow: '0 20px 40px rgba(0,0,0,0.15)',
//           },
//         },
//       },
//     },
//     MuiCardContent: {
//       styleOverrides: {
//         root: {
//           padding: '20px',
//           '&:last-child': {
//             paddingBottom: '20px',
//           },
//         },
//       },
//     },
//     MuiButton: {
//       styleOverrides: {
//         root: {
//           borderRadius: 12,
//           textTransform: 'none',
//           fontWeight: 600,
//           fontSize: '0.875rem',
//           padding: '8px 16px',
//           transition: 'all 0.2s ease',
//         },
//         contained: {
//           background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
//           boxShadow: '0 4px 16px rgba(102, 126, 234, 0.4)',
//           '&:hover': {
//             transform: 'translateY(-2px)',
//             boxShadow: '0 8px 24px rgba(102, 126, 234, 0.6)',
//           },
//         },
//       },
//     },
//     MuiLinearProgress: {
//       styleOverrides: {
//         root: {
//           borderRadius: 10,
//           height: 8,
//           background: 'rgba(255, 255, 255, 0.2)',
//         },
//         bar: {
//           borderRadius: 10,
//           background: 'linear-gradient(90deg, #667eea, #764ba2)',
//         },
//       },
//     },
//   },
// });

// export const HomeScreen = () => {
//   const [drawerOpen, setDrawerOpen] = useState(false);
//   const [timeframe, setTimeframe] = useState('all-time');
//   const [category, setCategory] = useState('all');
//   const [region, setRegion] = useState('all');
//   const [showTable, setShowTable] = useState(false);
//   const [selectedMetric, setSelectedMetric] = useState(null);
//   const [sortMenuAnchor, setSortMenuAnchor] = useState(null);
//   const [roleMenuAnchor, setRoleMenuAnchor] = useState(null);
//   const [currentRole, setCurrentRole] = useState('central-manager');
//   const [statsOrder, setStatsOrder] = useState([0, 1, 2, 3, 4, 5]);
//   const [loadingProgress, setLoadingProgress] = useState(0);
//   const [showBottomLoader, setShowBottomLoader] = useState(false);
//   const [selectedPincode, setSelectedPincode] = useState(null);
//   const [isTableLoading, setIsTableLoading] = useState(false);
//   const [fromDate, setFromDate] = useState(null);
//   const [toDate, setToDate] = useState(null);
//   const [dateRangeError, setDateRangeError] = useState('');
//   const tableRef = useRef(null);

//   // Role configuration
//   const roles = {
//     'shop-manager': {
//       name: 'Shop Manager',
//       icon: <Store />,
//       color: '#4caf50',
//       description: 'Individual store operations'
//     },
//     'area-manager': {
//       name: 'Area Manager',
//       icon: <SupervisorAccount />,
//       color: '#ff9800',
//       description: 'Regional area oversight'
//     },
//     'central-manager': {
//       name: 'Central Manager',
//       icon: <AdminPanelSettings />,
//       color: '#2196f3',
//       description: 'Overall operations management'
//     }
//   };

//   // Top 4 Pin codes for Central Manager
//   const topPinCodes = [
//     { pincode: '440001', city: 'Nagpur', orders: 1245, value: 875000, growth: '+12.5%' },
//     { pincode: '491441', city: 'Rajnandgaon', orders: 892, value: 623000, growth: '+8.7%' },
//     { pincode: '491001', city: 'Durg', orders: 756, value: 534000, growth: '+15.2%' },
//     { pincode: '492001', city: 'Raipur', orders: 1134, value: 798000, growth: '+10.3%' }
//   ];

//   const muiTheme = useTheme();
//   const isMobile = useMediaQuery(muiTheme.breakpoints.down('md'));

//   // Date validation function
//   const validateDateRange = (startDate, endDate) => {
//     if (!startDate || !endDate) {
//       return '';
//     }

//     const today = dayjs();
    
//     // Check if start date is before end date
//     if (startDate.isAfter(endDate)) {
//       return 'From date must be before To date';
//     }
    
//     // Check if dates are not in the future
//     if (startDate.isAfter(today) || endDate.isAfter(today)) {
//       return 'Dates cannot be in the future';
//     }
    
//     // Check 90-day restriction
//     const diffDays = endDate.diff(startDate, 'day');
    
//     if (diffDays > 90) {
//       return 'Date range cannot exceed 90 days';
//     }
    
//     return '';
//   };

//   // Handle timeframe change
//   const handleTimeframeChange = (value) => {
//     setTimeframe(value);
//     if (value !== 'custom-range') {
//       setFromDate(null);
//       setToDate(null);
//       setDateRangeError('');
//     }
//   };

//   // Handle date input changes
//   const handleFromDateChange = (newValue) => {
//     setFromDate(newValue);
//     const error = validateDateRange(newValue, toDate);
//     setDateRangeError(error);
//   };

//   const handleToDateChange = (newValue) => {
//     setToDate(newValue);
//     const error = validateDateRange(fromDate, newValue);
//     setDateRangeError(error);
//   };

//   // Date picker disable functions
//   const shouldDisableFromDate = (date) => {
//     return date.isAfter(dayjs());
//   };

//   const shouldDisableToDate = (date) => {
//     const today = dayjs();
//     if (date.isAfter(today)) return true;
//     if (fromDate && date.isBefore(fromDate)) return true;
//     if (fromDate && date.diff(fromDate, 'day') > 90) return true;
//     return false;
//   };

//   // Role-based data configuration
//   const getRoleBasedStats = () => {
//     const baseStats = {
//       'shop-manager': [
//         { title: 'Total Orders', value: '298', subtitle: '+8.2%', icon: ShoppingCart, color: 'primary', numericValue: 298 },
//         { title: 'Wallet', value: '₹240K', subtitle: '+12.5%', icon: AttachMoney, color: 'success', numericValue: 240000 },
//         { title: 'Happy Hours', value: '8', subtitle: '+3.2%', icon: TrendingUp, color: 'warning', numericValue: 8 },
//         { title: 'Horeca Sale', value: '₹84.7K', subtitle: '+15.3%', icon: ShowChart, color: 'info', numericValue: 84700 },
//         { title: 'Stock', value: '245', subtitle: '+2.8%', icon: Inventory, color: 'secondary', numericValue: 245 },
//         { title: 'Sale Quantity', value: '4,567', subtitle: '+5.9%', icon: Receipt, color: 'success', numericValue: 4567 },
//       ],
//       'area-manager': [
//         { title: 'Area Orders', value: '1,892', subtitle: '+8.7%', icon: ShoppingCart, color: 'primary', numericValue: 1892 },
//         { title: 'Area Wallet', value: '₹845K', subtitle: '+12.3%', icon: AttachMoney, color: 'success', numericValue: 845000 },
//         { title: 'Active Stores', value: '12', subtitle: '0%', icon: Store, color: 'info', numericValue: 12 },
//         { title: 'Area Horeca Sale', value: '₹245K', subtitle: '+11.2%', icon: ShowChart, color: 'warning', numericValue: 245000 },
//         { title: 'Area Stock', value: '2,845', subtitle: '+4.5%', icon: Inventory, color: 'secondary', numericValue: 2845 },
//         { title: 'Delivery Rate', value: '94%', subtitle: '+2.1%', icon: LocalShipping, color: 'success', numericValue: 94 },
//       ],
//       'central-manager': [
//         { title: 'Total Orders', value: '3,298', subtitle: '+8.2%', icon: ShoppingCart, color: 'primary', numericValue: 3298 },
//         { title: 'Wallet', value: '₹2.4M', subtitle: '+12.5%', icon: AttachMoney, color: 'success', numericValue: 2400000 },
//         { title: 'Happy Hours', value: '64', subtitle: '+3.2%', icon: TrendingUp, color: 'warning', numericValue: 64 },
//         { title: 'Horeca Sale', value: '₹847K', subtitle: '+15.3%', icon: ShowChart, color: 'info', numericValue: 847000 },
//         { title: 'Stock', value: '1,245', subtitle: '+2.8%', icon: Inventory, color: 'secondary', numericValue: 1245 },
//         { title: 'Sale Quantity', value: '45,670', subtitle: '+5.9%', icon: Receipt, color: 'success', numericValue: 45670 },
//       ]
//     };
//     return baseStats[currentRole] || baseStats['central-manager'];
//   };

//   // Sample data
//   const salesData = [
//     { month: 'Jan', sales: 120000, year: '2024' },
//     { month: 'Feb', sales: 135000, year: '2024' },
//     { month: 'Mar', sales: 148000, year: '2024' },
//     { month: 'Apr', sales: 162000, year: '2024' },
//     { month: 'May', sales: 178000, year: '2024' },
//     { month: 'Jun', sales: 195000, year: '2024' },
//     { month: 'Jul', sales: 210000, year: '2024' },
//     { month: 'Aug', sales: 185000, year: '2024' },
//     { month: 'Sep', sales: 225000, year: '2024' },
//     { month: 'Oct', sales: 245000, year: '2024' },
//     { month: 'Nov', sales: 268000, year: '2024' },
//     { month: 'Dec', sales: 290000, year: '2024' }
//   ];

//   const worstProducts = [
//     { name: 'Poultry', performance: 24, count: 156 },
//     { name: 'Oil', performance: 32, count: 243 },
//     { name: 'Masale', performance: 18, count: 89 },
//     { name: 'Eggs', performance: 45, count: 312 },
//     { name: 'Ready to Cook', performance: 38, count: 178 }
//   ];

//   const deliveryStatus = [
//     { name: 'Accepted', count: 245, color: '#4caf50' },
//     { name: 'Delivered', count: 189, color: '#2196f3' },
//     { name: 'Out for Delivery', count: 67, color: '#ff9800' },
//     { name: 'Pending', count: 123, color: '#f44336' },
//     { name: 'Delayed Orders', count: 34, color: '#9c27b0', isBold: true },
//     { name: 'Total Orders', count: 658, color: '#333', isBold: true }
//   ];

//   const menuItems = [
//     { text: 'Dashboard', icon: <DashboardIcon />, active: true },
//     { text: 'Products', icon: <Inventory /> },
//     { text: 'Orders', icon: <Receipt /> },
//     { text: 'Customers', icon: <People /> },
//     { text: 'Analytics', icon: <Analytics /> }
//   ];

//   // Sample table data for different metrics with pincode filtering
//   const tableData = {
//     'Total Orders': [
//       { id: 1, orderId: 'ORD-2024-001', customer: 'SUGAR RESTONT', amount: 1299, status: 'Completed', date: '2024-07-15', type: 'ONLINE', pincode: '440001' },
//       { id: 2, orderId: 'ORD-2024-002', customer: 'HOTEL GRAND', amount: 899, status: 'Processing', date: '2024-07-16', type: 'ONLINE', pincode: '491441' },
//       { id: 3, orderId: 'ORD-2024-003', customer: 'RETAIL STORE', amount: 549, status: 'Shipped', date: '2024-07-17', type: 'ONLINE', pincode: '491001' },
//       { id: 4, orderId: 'ORD-2024-004', customer: 'WHOLESALE MART', amount: 299, status: 'Completed', date: '2024-07-18', type: 'OFFLINE', pincode: '492001' },
//       { id: 5, orderId: 'ORD-2024-005', customer: 'CAFE DELIGHT', amount: 799, status: 'Processing', date: '2024-07-18', type: 'OFFLINE', pincode: '440001' },
//       { id: 6, orderId: 'ORD-2024-006', customer: 'RESTAURANT ABC', amount: 1199, status: 'Delivered', date: '2024-07-19', type: 'ONLINE', pincode: '440001' },
//       { id: 7, orderId: 'ORD-2024-007', customer: 'HOTEL XYZ', amount: 999, status: 'Processing', date: '2024-07-19', type: 'OFFLINE', pincode: '491441' },
//       { id: 8, orderId: 'ORD-2024-008', customer: 'CAFE FRESH', amount: 649, status: 'Completed', date: '2024-07-20', type: 'ONLINE', pincode: '491001' },
//       { id: 9, orderId: 'ORD-2024-009', customer: 'MARKET PLUS', amount: 399, status: 'Shipped', date: '2024-07-20', type: 'OFFLINE', pincode: '492001' },
//       { id: 10, orderId: 'ORD-2024-010', customer: 'SUPERMART', amount: 899, status: 'Delivered', date: '2024-07-21', type: 'ONLINE', pincode: '440001' },
//     ],
//     'Total Orders - Online Orders': [
//       { id: 1, orderId: 'ORD-2024-001', customer: 'SUGAR RESTONT', amount: 1299, status: 'Completed', date: '2024-07-15', type: 'ONLINE', pincode: '440001' },
//       { id: 2, orderId: 'ORD-2024-002', customer: 'HOTEL GRAND', amount: 899, status: 'Processing', date: '2024-07-16', type: 'ONLINE', pincode: '491441' },
//       { id: 3, orderId: 'ORD-2024-003', customer: 'RETAIL STORE', amount: 549, status: 'Shipped', date: '2024-07-17', type: 'ONLINE', pincode: '491001' },
//       { id: 6, orderId: 'ORD-2024-006', customer: 'RESTAURANT ABC', amount: 1199, status: 'Delivered', date: '2024-07-19', type: 'ONLINE', pincode: '440001' },
//       { id: 8, orderId: 'ORD-2024-008', customer: 'CAFE FRESH', amount: 649, status: 'Completed', date: '2024-07-20', type: 'ONLINE', pincode: '491001' },
//       { id: 10, orderId: 'ORD-2024-010', customer: 'SUPERMART', amount: 899, status: 'Delivered', date: '2024-07-21', type: 'ONLINE', pincode: '440001' },
//     ],
//     'Total Orders - Offline Orders': [
//       { id: 4, orderId: 'ORD-2024-004', customer: 'WHOLESALE MART', amount: 299, status: 'Completed', date: '2024-07-18', type: 'OFFLINE', pincode: '492001' },
//       { id: 5, orderId: 'ORD-2024-005', customer: 'CAFE DELIGHT', amount: 799, status: 'Processing', date: '2024-07-18', type: 'OFFLINE', pincode: '440001' },
//       { id: 7, orderId: 'ORD-2024-007', customer: 'HOTEL XYZ', amount: 999, status: 'Processing', date: '2024-07-19', type: 'OFFLINE', pincode: '491441' },
//       { id: 9, orderId: 'ORD-2024-009', customer: 'MARKET PLUS', amount: 399, status: 'Shipped', date: '2024-07-20', type: 'OFFLINE', pincode: '492001' },
//     ],
//     'Wallet - Active Credits': [
//       { id: 1, customer: 'SUGAR RESTONT', balance: 25000, lastTopup: '2024-07-15', totalSpent: 125000, creditLimit: 50000, pincode: '440001', creditType: 'Active' },
//       { id: 2, customer: 'HOTEL GRAND', balance: 18000, lastTopup: '2024-07-16', totalSpent: 89000, creditLimit: 30000, pincode: '491441', creditType: 'Active' },
//       { id: 3, customer: 'RETAIL STORE', balance: 12000, lastTopup: '2024-07-17', totalSpent: 156000, creditLimit: 25000, pincode: '491001', creditType: 'Active' },
//       { id: 4, customer: 'WHOLESALE MART', balance: 45000, lastTopup: '2024-07-18', totalSpent: 234000, creditLimit: 100000, pincode: '492001', creditType: 'Active' },
//     ],
//     'Wallet - Pending Credits': [
//       { id: 5, customer: 'CAFE DELIGHT', balance: 8500, lastTopup: '2024-07-18', totalSpent: 67000, creditLimit: 20000, pincode: '440001', creditType: 'Pending' },
//       { id: 6, customer: 'RESTAURANT ABC', balance: 32000, lastTopup: '2024-07-19', totalSpent: 198000, creditLimit: 60000, pincode: '440001', creditType: 'Pending' },
//       { id: 7, customer: 'HOTEL XYZ', balance: 22000, lastTopup: '2024-07-19', totalSpent: 145000, creditLimit: 40000, pincode: '491441', creditType: 'Pending' },
//     ],
//     'Wallet': [
//       { id: 1, customerName: 'SUGAR RESTONT', currentBalance: 25000, lastTopUp: '2024-07-15', totalSpent: 125000, creditLimit: 50000, pincode: '440001' },
//       { id: 2, customerName: 'HOTEL GRAND', currentBalance: 18000, lastTopUp: '2024-07-16', totalSpent: 89000, creditLimit: 30000, pincode: '491441' },
//       { id: 3, customerName: 'RETAIL STORE', currentBalance: 12000, lastTopUp: '2024-07-17', totalSpent: 156000, creditLimit: 25000, pincode: '491001' },
//       { id: 4, customerName: 'WHOLESALE MART', currentBalance: 45000, lastTopUp: '2024-07-18', totalSpent: 234000, creditLimit: 100000, pincode: '492001' },
//       { id: 5, customerName: 'CAFE DELIGHT', currentBalance: 8500, lastTopUp: '2024-07-18', totalSpent: 67000, creditLimit: 20000, pincode: '440001' },
//     ],
//     'Happy Hours': [
//       { id: 1, timeSlot: '10:00 AM - 12:00 PM', discountPercent: '20%', totalOrders: 45, totalRevenue: 12500, status: 'Active', location: 'Nagpur', pincode: '440001' },
//       { id: 2, timeSlot: '2:00 PM - 4:00 PM', discountPercent: '15%', totalOrders: 38, totalRevenue: 8900, status: 'Active', location: 'Raipur', pincode: '491441' },
//       { id: 3, timeSlot: '6:00 PM - 8:00 PM', discountPercent: '25%', totalOrders: 67, totalRevenue: 18700, status: 'Active', location: 'Bilaspur', pincode: '491001' },
//       { id: 4, timeSlot: '8:00 PM - 10:00 PM', discountPercent: '30%', totalOrders: 23, totalRevenue: 5600, status: 'Inactive', location: 'Korba', pincode: '492001' },
//       { id: 5, timeSlot: '12:00 PM - 2:00 PM', discountPercent: '18%', totalOrders: 52, totalRevenue: 15200, status: 'Active', location: 'Nagpur', pincode: '440001' },
//     ],
//     'Horeca Sale': [
//       { id: 1, restaurantName: 'SUGAR RESTONT', businessType: 'Fine Dining', totalSales: 125000, totalOrders: 89, avgOrderValue: 1400, growthRate: '+15.2%', location: 'Nagpur', pincode: '440001' },
//       { id: 2, restaurantName: 'HOTEL GRAND', businessType: 'Hotel', totalSales: 89000, totalOrders: 67, avgOrderValue: 1328, growthRate: '+8.7%', location: 'Raipur', pincode: '491441' },
//       { id: 3, restaurantName: 'CAFE DELIGHT', businessType: 'Cafe', totalSales: 67000, totalOrders: 124, avgOrderValue: 540, growthRate: '+12.3%', location: 'Nagpur', pincode: '440001' },
//       { id: 4, restaurantName: 'FAST FOOD CHAIN', businessType: 'QSR', totalSales: 156000, totalOrders: 245, avgOrderValue: 637, growthRate: '+22.1%', location: 'Bilaspur', pincode: '491001' },
//       { id: 5, restaurantName: 'BANQUET HALL', businessType: 'Catering', totalSales: 234000, totalOrders: 45, avgOrderValue: 5200, growthRate: '+18.9%', location: 'Korba', pincode: '492001' },
//     ],
//     'Stock': [
//       { id: 1, productName: 'Poultry', productCategory: 'Meat', currentStock: 245, reorderLevel: 100, lastRestocked: '2024-07-15', stockStatus: 'Good', location: 'Nagpur', pincode: '440001' },
//       { id: 2, productName: 'Oil', productCategory: 'Cooking Oil', currentStock: 89, reorderLevel: 50, lastRestocked: '2024-07-16', stockStatus: 'Low', location: 'Raipur', pincode: '491441' },
//       { id: 3, productName: 'Masale', productCategory: 'Spices', currentStock: 567, reorderLevel: 200, lastRestocked: '2024-07-17', stockStatus: 'Good', location: 'Bilaspur', pincode: '491001' },
//       { id: 4, productName: 'Eggs', productCategory: 'Dairy', currentStock: 123, reorderLevel: 150, lastRestocked: '2024-07-18', stockStatus: 'Critical', location: 'Korba', pincode: '492001' },
//       { id: 5, productName: 'Ready to Cook', productCategory: 'Processed', currentStock: 345, reorderLevel: 100, lastRestocked: '2024-07-18', stockStatus: 'Good', location: 'Nagpur', pincode: '440001' },
//     ],
//     'Sale Quantity': [
//       { id: 1, productName: 'Poultry', quantitySold: 1250, unitOfMeasure: 'Kg', totalRevenue: 87500, avgPrice: 70, growthRate: '+8.5%', location: 'Nagpur', pincode: '440001' },
//       { id: 2, productName: 'Oil', quantitySold: 890, unitOfMeasure: 'Liters', totalRevenue: 125000, avgPrice: 140, growthRate: '+12.3%', location: 'Raipur', pincode: '491441' },
//       { id: 3, productName: 'Masale', quantitySold: 450, unitOfMeasure: 'Kg', totalRevenue: 67500, avgPrice: 150, growthRate: '+15.7%', location: 'Bilaspur', pincode: '491001' },
//       { id: 4, productName: 'Eggs', quantitySold: 2340, unitOfMeasure: 'Dozens', totalRevenue: 23400, avgPrice: 10, growthRate: '+5.2%', location: 'Korba', pincode: '492001' },
//       { id: 5, productName: 'Ready to Cook', quantitySold: 678, unitOfMeasure: 'Packets', totalRevenue: 54240, avgPrice: 80, growthRate: '+18.9%', location: 'Nagpur', pincode: '440001' },
//     ],
//     'Accepted': [
//       { id: 1, orderId: 'ORD-2024-001', customer: 'SUGAR RESTONT', amount: 1299, status: 'Accepted', date: '2024-07-15', time: '10:30 AM', pincode: '440001' },
//       { id: 2, orderId: 'ORD-2024-002', customer: 'HOTEL GRAND', amount: 899, status: 'Accepted', date: '2024-07-16', time: '11:45 AM', pincode: '491441' },
//       { id: 3, orderId: 'ORD-2024-003', customer: 'CAFE DELIGHT', amount: 549, status: 'Accepted', date: '2024-07-17', time: '09:15 AM', pincode: '491001' },
//     ],
//     'Delivered': [
//       { id: 1, orderId: 'ORD-2024-006', customer: 'RESTAURANT ABC', amount: 1199, status: 'Delivered', date: '2024-07-15', deliveryTime: '12:45 PM', pincode: '440001' },
//       { id: 2, orderId: 'ORD-2024-007', customer: 'HOTEL XYZ', amount: 999, status: 'Delivered', date: '2024-07-16', deliveryTime: '01:30 PM', pincode: '491441' },
//     ],
//     'Out for Delivery': [
//       { id: 1, orderId: 'ORD-2024-011', customer: 'FOOD COURT', amount: 749, status: 'Out for Delivery', date: '2024-07-19', driver: 'John Doe', pincode: '440001' },
//       { id: 2, orderId: 'ORD-2024-012', customer: 'HOTEL PALACE', amount: 1099, status: 'Out for Delivery', date: '2024-07-19', driver: 'Mike Smith', pincode: '491441' },
//     ],
//     'Pending': [
//       { id: 1, orderId: 'ORD-2024-016', customer: 'RESTAURANT DEF', amount: 949, status: 'Pending', date: '2024-07-19', reason: 'Payment Processing', pincode: '440001' },
//       { id: 2, orderId: 'ORD-2024-017', customer: 'HOTEL ROYAL', amount: 1249, status: 'Pending', date: '2024-07-19', reason: 'Stock Verification', pincode: '491441' },
//     ],
    
//     // Area Manager specific data
//     'Area Orders': [
//       { id: 1, branchName: 'Nagpur Central', totalOrders: 245, completedOrders: 198, pendingOrders: 47, revenue: 156700, avgOrderValue: 639, pincode: '440001' },
//       { id: 2, branchName: 'Raipur Main', totalOrders: 189, completedOrders: 156, pendingOrders: 33, revenue: 124300, avgOrderValue: 658, pincode: '491441' },
//       { id: 3, branchName: 'Bilaspur Store', totalOrders: 167, completedOrders: 134, pendingOrders: 33, revenue: 98900, avgOrderValue: 592, pincode: '491001' },
//       { id: 4, branchName: 'Korba Branch', totalOrders: 134, completedOrders: 112, pendingOrders: 22, revenue: 78900, avgOrderValue: 589, pincode: '492001' },
//     ],
    
//     'Area Wallet': [
//       { id: 1, branchName: 'Nagpur Central', totalBalance: 89000, activeCredits: 12, pendingCredits: 3, totalCreditLimit: 450000, utilization: '67%', pincode: '440001' },
//       { id: 2, branchName: 'Raipur Main', totalBalance: 67300, activeCredits: 9, pendingCredits: 2, totalCreditLimit: 350000, utilization: '54%', pincode: '491441' },
//       { id: 3, branchName: 'Bilaspur Store', totalBalance: 45600, activeCredits: 7, pendingCredits: 1, totalCreditLimit: 280000, utilization: '48%', pincode: '491001' },
//       { id: 4, branchName: 'Korba Branch', totalBalance: 34900, activeCredits: 5, pendingCredits: 2, totalCreditLimit: 200000, utilization: '62%', pincode: '492001' },
//     ],
    
//     'Active Stores': [
//       { id: 1, storeName: 'Nagpur Central', storeType: 'Flagship', status: 'Active', lastActivity: '2024-07-21 09:45 AM', dailyOrders: 45, monthlyRevenue: 234000, pincode: '440001' },
//       { id: 2, storeName: 'Raipur Main', storeType: 'Standard', status: 'Active', lastActivity: '2024-07-21 10:15 AM', dailyOrders: 32, monthlyRevenue: 189000, pincode: '491441' },
//       { id: 3, storeName: 'Bilaspur Store', storeType: 'Standard', status: 'Active', lastActivity: '2024-07-21 08:30 AM', dailyOrders: 28, monthlyRevenue: 156000, pincode: '491001' },
//       { id: 4, storeName: 'Korba Branch', storeType: 'Compact', status: 'Active', lastActivity: '2024-07-21 11:20 AM', dailyOrders: 19, monthlyRevenue: 98000, pincode: '492001' },
//     ],
    
//     'Area Horeca Sale': [
//       { id: 1, region: 'Nagpur Zone', totalSales: 156700, totalOrders: 234, avgOrderValue: 670, growthRate: '+18.5%', activeRestaurants: 45, location: 'Nagpur' },
//       { id: 2, region: 'Raipur Zone', totalSales: 134200, totalOrders: 198, avgOrderValue: 678, growthRate: '+12.3%', activeRestaurants: 38, location: 'Raipur' },
//       { id: 3, region: 'Bilaspur Zone', totalSales: 98900, totalOrders: 156, avgOrderValue: 634, growthRate: '+15.7%', activeRestaurants: 29, location: 'Bilaspur' },
//       { id: 4, region: 'Korba Zone', totalSales: 78600, totalOrders: 123, avgOrderValue: 639, growthRate: '+9.2%', activeRestaurants: 22, location: 'Korba' },
//     ],
    
//     'Area Stock': [
//       { id: 1, branchName: 'Nagpur Central', totalProducts: 245, lowStockItems: 12, criticalItems: 3, stockValue: 567000, lastUpdated: '2024-07-21', pincode: '440001' },
//       { id: 2, branchName: 'Raipur Main', totalProducts: 198, lowStockItems: 8, criticalItems: 2, stockValue: 423000, lastUpdated: '2024-07-21', pincode: '491441' },
//       { id: 3, branchName: 'Bilaspur Store', totalProducts: 167, lowStockItems: 6, criticalItems: 1, stockValue: 345000, lastUpdated: '2024-07-21', pincode: '491001' },
//       { id: 4, branchName: 'Korba Branch', totalProducts: 134, lowStockItems: 9, criticalItems: 4, stockValue: 256000, lastUpdated: '2024-07-21', pincode: '492001' },
//     ],
    
//     'Delivery Rate': [
//       { id: 1, branchName: 'Nagpur Central', totalDeliveries: 245, successfulDeliveries: 231, deliveryRate: '94.3%', avgDeliveryTime: '45 min', onTimeDeliveries: 218, pincode: '440001' },
//       { id: 2, branchName: 'Raipur Main', totalDeliveries: 198, successfulDeliveries: 186, deliveryRate: '93.9%', avgDeliveryTime: '48 min', onTimeDeliveries: 172, pincode: '491441' },
//       { id: 3, branchName: 'Bilaspur Store', totalDeliveries: 167, successfulDeliveries: 159, deliveryRate: '95.2%', avgDeliveryTime: '42 min', onTimeDeliveries: 149, pincode: '491001' },
//       { id: 4, branchName: 'Korba Branch', totalDeliveries: 134, successfulDeliveries: 125, deliveryRate: '93.3%', avgDeliveryTime: '52 min', onTimeDeliveries: 116, pincode: '492001' },
//     ],
//   };

//   // Excel export functionality
//   const exportToExcel = (data, filename) => {
//     const headers = Object.keys(data[0]).filter(key => key !== 'id');
//     const csvContent = [
//       headers.join(','),
//       ...data.map(row => 
//         headers.map(header => {
//           const value = row[header];
//           return typeof value === 'string' && value.includes(',') 
//             ? `"${value}"` 
//             : value;
//         }).join(',')
//       )
//     ].join('\n');

//     const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
//     const link = document.createElement('a');
//     if (link.download !== undefined) {
//       const url = URL.createObjectURL(blob);
//       link.setAttribute('href', url);
//       link.setAttribute('download', `${filename}.csv`);
//       link.style.visibility = 'hidden';
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//     }
//   };

//   const handlePincodeClick = (pincode, city) => {
//     setSelectedPincode({ pincode, city });
//     setSelectedMetric('Pincode Data');
//     setShowBottomLoader(true);
//     setLoadingProgress(0);
//     setShowTable(false);

//     const progressInterval = setInterval(() => {
//       setLoadingProgress((prev) => {
//         if (prev >= 100) {
//           clearInterval(progressInterval);
//           setTimeout(() => {
//             setShowBottomLoader(false);
//             setShowTable(true);
            
//             setTimeout(() => {
//               tableRef.current?.scrollIntoView({ 
//                 behavior: 'smooth',
//                 block: 'start'
//               });
//             }, 100);
//           }, 300);
//           return 100;
//         }
//         return prev + 2;
//       });
//     }, 40);
//   };

//   const handleStatCardClick = (metricTitle, isBreakdown = false) => {
//     // Prevent multiple clicks while loading
//     if (isTableLoading || showBottomLoader) {
//       return;
//     }

//     setIsTableLoading(true);
//     setSelectedMetric(metricTitle);
//     setSelectedPincode(null);
//     setShowBottomLoader(true);
//     setLoadingProgress(0);
//     setShowTable(false);

//     const progressInterval = setInterval(() => {
//       setLoadingProgress((prev) => {
//         if (prev >= 100) {
//           clearInterval(progressInterval);
//           setTimeout(() => {
//             setShowBottomLoader(false);
//             setShowTable(true);
//             setIsTableLoading(false);
            
//             // Smooth scroll to table after it's rendered
//             setTimeout(() => {
//               tableRef.current?.scrollIntoView({ 
//                 behavior: 'smooth',
//                 block: 'start'
//               });
//             }, 200);
//           }, 300);
//           return 100;
//         }
//         return prev + 3; // Slightly faster progress
//       });
//     }, 35); // Slightly faster interval
//   };

//   const handleChartClick = (data) => {
//     if (data && data.activeLabel) {
//       setSelectedMetric('Monthly Sales');
//       setSelectedPincode(null);
//       setShowBottomLoader(true);
//       setLoadingProgress(0);
//       setShowTable(false);

//       const progressInterval = setInterval(() => {
//         setLoadingProgress((prev) => {
//           if (prev >= 100) {
//             clearInterval(progressInterval);
//             setTimeout(() => {
//               setShowBottomLoader(false);
//               setShowTable(true);
              
//               setTimeout(() => {
//                 tableRef.current?.scrollIntoView({ 
//                   behavior: 'smooth',
//                   block: 'start'
//                 });
//               }, 100);
//             }, 300);
//             return 100;
//           }
//           return prev + 2;
//         });
//       }, 40);
//     }
//   };

//   const handleDeliveryStatusClick = (statusName) => {
//     if (statusName === 'Total Orders' || statusName === 'Delayed Orders') return;
    
//     setSelectedMetric(statusName);
//     setSelectedPincode(null);
//     setShowBottomLoader(true);
//     setLoadingProgress(0);
//     setShowTable(false);

//     const progressInterval = setInterval(() => {
//       setLoadingProgress((prev) => {
//         if (prev >= 100) {
//           clearInterval(progressInterval);
//           setTimeout(() => {
//             setShowBottomLoader(false);
//             setShowTable(true);
            
//             setTimeout(() => {
//               tableRef.current?.scrollIntoView({ 
//                 behavior: 'smooth',
//                 block: 'start'
//               });
//             }, 100);
//           }, 300);
//           return 100;
//         }
//         return prev + 2;
//       });
//     }, 40);
//   };

//   const handleRoleChange = (role) => {
//     setCurrentRole(role);
//     setRoleMenuAnchor(null);
//     setSelectedMetric(null);
//     setSelectedPincode(null);
//     setShowTable(false);
//   };

//   const handleSortClick = (event) => {
//     setSortMenuAnchor(event.currentTarget);
//   };

//   const handleSortClose = () => {
//     setSortMenuAnchor(null);
//   };

//   const handleSortSelect = (sortType) => {
//     const currentStats = getRoleBasedStats();
//     let newOrder = [...Array(currentStats.length).keys()];
    
//     switch (sortType) {
//       case 'highest':
//         newOrder.sort((a, b) => currentStats[b].numericValue - currentStats[a].numericValue);
//         break;
//       case 'lowest':
//         newOrder.sort((a, b) => currentStats[a].numericValue - currentStats[b].numericValue);
//         break;
//       case 'alphabetical':
//         newOrder.sort((a, b) => currentStats[a].title.localeCompare(currentStats[b].title));
//         break;
//       default:
//         newOrder = [...Array(currentStats.length).keys()];
//     }
    
//     setStatsOrder(newOrder);
//     setSortMenuAnchor(null);
//   };

//   const getSortedStats = () => {
//     const currentStats = getRoleBasedStats();
//     return statsOrder.slice(0, currentStats.length).map(index => currentStats[index]);
//   };

//   const getStatusColor = (status) => {
//     switch (status?.toLowerCase()) {
//       case 'completed':
//       case 'delivered':
//       case 'active':
//       case 'good':
//       case 'success':
//         return 'success';
//       case 'processing':
//       case 'pending':
//       case 'accepted':
//       case 'low':
//       case 'warning':
//         return 'warning';
//       case 'shipped':
//       case 'out for delivery':
//       case 'info':
//         return 'info';
//       case 'critical':
//       case 'inactive':
//       case 'failed':
//       case 'error':
//         return 'error';
//       default:
//         return 'default';
//     }
//   };

//   const renderTable = () => {
//     if (!selectedMetric) return null;

//     let data = [];
//     let title = selectedMetric;

//     // Handle pincode filtering
//     if (selectedPincode) {
//       const pincodeData = [];
      
//       const ordersData = tableData['Total Orders']?.filter(item => item.pincode === selectedPincode.pincode) || [];
//       const walletData = tableData['Wallet']?.filter(item => item.pincode === selectedPincode.pincode) || [];
//       const happyHoursData = tableData['Happy Hours']?.filter(item => item.pincode === selectedPincode.pincode) || [];
//       const horecaData = tableData['Horeca Sale']?.filter(item => item.pincode === selectedPincode.pincode) || [];
//       const stockData = tableData['Stock']?.filter(item => item.pincode === selectedPincode.pincode) || [];
      
//       data = [
//         ...ordersData.map(item => ({...item, dataType: 'Order'})),
//         ...walletData.map(item => ({...item, dataType: 'Wallet'})),
//         ...happyHoursData.map(item => ({...item, dataType: 'Happy Hour'})),
//         ...horecaData.map(item => ({...item, dataType: 'Horeca'})),
//         ...stockData.map(item => ({...item, dataType: 'Stock'})),
//       ];
      
//       title = `${selectedPincode.city} (${selectedPincode.pincode}) - Complete Data`;
//     } else if (tableData[selectedMetric]) {
//       data = tableData[selectedMetric];
//     }

//     if (!data || data.length === 0) return null;

//     // Get all possible columns from all rows to handle mixed data structures
//     const allColumns = new Set();
//     data.forEach(row => {
//       Object.keys(row).forEach(key => {
//         if (key !== 'id') {
//           allColumns.add(key);
//         }
//       });
//     });

//     // Filter out columns that are empty/null/undefined in ALL rows
//     const validColumns = Array.from(allColumns).filter(column => {
//       return data.some(row => 
//         row[column] !== null && 
//         row[column] !== undefined && 
//         row[column] !== '' &&
//         String(row[column]).trim() !== ''
//       );
//     });

//     // Define column priority order for better UX
//     const columnPriority = [
//       'orderId', 'customerName', 'customer', 'branchName', 'storeName', 'restaurantName', 'productName', 'region',
//       'amount', 'totalSales', 'totalRevenue', 'revenue', 'currentBalance', 'balance',
//       'status', 'stockStatus', 'storeType', 'businessType', 'productCategory',
//       'date', 'lastTopUp', 'lastRestocked', 'lastActivity', 'lastUpdated',
//       'totalOrders', 'completedOrders', 'pendingOrders', 'quantitySold', 'currentStock',
//       'type', 'timeSlot', 'discountPercent', 'discount', 'growthRate', 'growth',
//       'totalSpent', 'creditLimit', 'creditType', 'utilization', 'deliveryRate',
//       'location', 'dataType', 'pincode'
//     ];

//     // Sort columns by priority, then alphabetically
//     const columns = validColumns.sort((a, b) => {
//       const aPriority = columnPriority.indexOf(a);
//       const bPriority = columnPriority.indexOf(b);
      
//       if (aPriority !== -1 && bPriority !== -1) {
//         return aPriority - bPriority;
//       } else if (aPriority !== -1) {
//         return -1;
//       } else if (bPriority !== -1) {
//         return 1;
//       } else {
//         return a.localeCompare(b);
//       }
//     });

//     return (
//       <Slide direction="up" in={showTable} timeout={800}>
//         <Card ref={tableRef} sx={{ mt: 3 }}>
//           <CardContent>
//             <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
//               <Box>
//                 <Typography variant="h6" gutterBottom>
//                   {title} - Detailed View
//                 </Typography>
//                 {selectedPincode && (
//                   <Box display="flex" alignItems="center" gap={1} mb={1}>
//                     <LocationOn color="primary" fontSize="small" />
//                     <Typography variant="body2" color="text.secondary">
//                       Showing data for {selectedPincode.city} - Pin Code: {selectedPincode.pincode}
//                     </Typography>
//                     <Button
//                       size="small"
//                       onClick={() => {
//                         setSelectedPincode(null);
//                         setSelectedMetric(null);
//                         setShowTable(false);
//                       }}
//                       variant="outlined"
//                       sx={{ ml: 2 }}
//                     >
//                       Clear Filter
//                     </Button>
//                   </Box>
//                 )}
//               </Box>
//               <Button
//                 variant="contained"
//                 startIcon={<FileDownload />}
//                 onClick={() => exportToExcel(data, `${title.replace(/\s+/g, '_')}_export`)}
//                 size="small"
//                 sx={{ ml: 2 }}
//               >
//                 Export XLSX
//               </Button>
//             </Box>
//             <TableContainer sx={{ 
//               maxHeight: 500,
//               border: '1px solid #e0e0e0',
//               borderRadius: 2,
//               '& .MuiTableCell-root': {
//                 borderBottom: '1px solid #f5f5f5',
//               },
//               '& .MuiTableRow-root:hover': {
//                 backgroundColor: '#f9f9f9',
//               }
//             }}>
//               <Table size="small" stickyHeader>
//                 <TableHead>
//                   <TableRow>
//                     {columns.map((column) => (
//                       <TableCell 
//                         key={column} 
//                         sx={{ 
//                           fontWeight: 'bold', 
//                           textTransform: 'capitalize',
//                           backgroundColor: '#fafafa',
//                           color: '#333',
//                           fontSize: '0.875rem',
//                           padding: '14px 16px',
//                           borderBottom: '2px solid #e0e0e0',
//                           whiteSpace: 'nowrap'
//                         }}
//                       >
//                         {column.replace(/([A-Z])/g, ' $1').trim()}
//                       </TableCell>
//                     ))}
//                   </TableRow>
//                 </TableHead>
//                 <TableBody>
//                   {data.map((row) => (
//                     <TableRow key={row.id} hover>
//                       {columns.map((column) => (
//                         <TableCell 
//                           key={column}
//                           sx={{
//                             padding: '12px 16px',
//                             fontSize: '0.85rem',
//                             color: '#555',
//                             whiteSpace: 'nowrap',
//                             overflow: 'hidden',
//                             textOverflow: 'ellipsis',
//                             maxWidth: '200px'
//                           }}
//                         >
//                           {(() => {
//                             const value = row[column];
                            
//                             // Handle null/undefined/empty values
//                             if (value === null || value === undefined || value === '') {
//                               return (
//                                 <span style={{ 
//                                   color: '#bbb', 
//                                   fontStyle: 'italic',
//                                   fontSize: '0.8rem'
//                                 }}>
//                                   —
//                                 </span>
//                               );
//                             }
                            
//                             // Handle status column
//                             if (['status', 'stockStatus'].includes(column)) {
//                               return (
//                                 <Chip 
//                                   label={value} 
//                                   size="small" 
//                                   color={getStatusColor(value)}
//                                   variant="filled"
//                                   sx={{
//                                     fontSize: '0.75rem',
//                                     height: '24px',
//                                     fontWeight: 'medium'
//                                   }}
//                                 />
//                               );
//                             }
                            
//                             // Handle currency columns
//                             if (['sales', 'amount', 'totalSpent', 'revenue', 'totalRevenue', 'totalSales', 'balance', 'currentBalance', 'creditLimit', 'totalCreditLimit', 'stockValue', 'avgOrderValue', 'avgPrice', 'monthlyRevenue'].includes(column)) {
//                               const numValue = Number(value);
//                               return (
//                                 <span style={{ 
//                                   fontWeight: '600',
//                                   color: '#2e7d32'
//                                 }}>
//                                   {isNaN(numValue) ? value : `₹${numValue.toLocaleString()}`}
//                                 </span>
//                               );
//                             }
                            
//                             // Handle percentage columns
//                             if (['discount', 'discountPercent', 'growthRate', 'growth', 'utilization', 'deliveryRate'].includes(column) && String(value).includes('%')) {
//                               return (
//                                 <span style={{
//                                   color: column === 'deliveryRate' || column === 'utilization' ? '#1976d2' : 
//                                         String(value).includes('+') ? '#2e7d32' : '#d32f2f',
//                                   fontWeight: '600'
//                                 }}>
//                                   {value}
//                                 </span>
//                               );
//                             }

//                             // Handle order ID / transaction IDs
//                             if (column === 'orderId' || column.toLowerCase().includes('id')) {
//                               return (
//                                 <span style={{
//                                   fontFamily: 'monospace',
//                                   backgroundColor: '#f5f5f5',
//                                   padding: '2px 6px',
//                                   borderRadius: '3px',
//                                   fontSize: '0.8rem'
//                                 }}>
//                                   {value}
//                                 </span>
//                               );
//                             }
                            
//                             // Default value display
//                             const displayValue = String(value).trim();
//                             return displayValue || (
//                               <span style={{ 
//                                 color: '#bbb', 
//                                 fontStyle: 'italic',
//                                 fontSize: '0.8rem'
//                               }}>
//                                 —
//                               </span>
//                             );
//                           })()}
//                         </TableCell>
//                       ))}
//                     </TableRow>
//                   ))}
//                 </TableBody>
//               </Table>
//             </TableContainer>
//           </CardContent>
//         </Card>
//       </Slide>
//     );
//   };

//   const StatCard = ({ title, value, subtitle, icon: Icon, color = 'primary', index }) => {
//     const [isHovered, setIsHovered] = useState(false);
//     const [tooltipOpen, setTooltipOpen] = useState(false);
    
//     const currentStats = getRoleBasedStats();
//     const numericValue = currentStats.find(stat => stat.title === title)?.numericValue || 0;
    
//     // Breakdown data for tooltips
//     const getBreakdownData = () => {
//       switch (title) {
//         case 'Total Orders':
//           return [
//             { label: 'Online Orders', value: 1890, color: '#4CAF50' },
//             { label: 'Offline Orders', value: 1408, color: '#FF9800' }
//           ];
//         case 'Wallet':
//           return [
//             { label: 'Active Credits', value: 1920000, color: '#2196F3' },
//             { label: 'Pending Credits', value: 480000, color: '#FFC107' }
//           ];
//         case 'Happy Hours':
//           return [
//             { label: 'Morning (6-12)', value: 38, color: '#FF5722' },
//             { label: 'Evening (6-10)', value: 26, color: '#9C27B0' }
//           ];
//         case 'Horeca Sale':
//           return [
//             { label: 'Fine Dining', value: 508000, color: '#4CAF50' },
//             { label: 'Quick Service', value: 339000, color: '#FF9800' }
//           ];
//         case 'Stock':
//           return [
//             { label: 'In Stock', value: 1045, color: '#4CAF50' },
//             { label: 'Low Stock', value: 200, color: '#FF5722' }
//           ];
//         case 'Sale Quantity':
//           return [
//             { label: 'Bulk Orders', value: 27000, color: '#2196F3' },
//             { label: 'Retail Orders', value: 18670, color: '#9C27B0' }
//           ];
//         default:
//           return [];
//       }
//     };

//     const breakdownData = getBreakdownData();

//     // Tooltip content component
//     const TooltipContent = () => (
//       <Box sx={{ p: 1, minWidth: 200 }}>
//         <Typography variant="subtitle2" fontWeight="bold" sx={{ mb: 1 }}>
//           {title} Breakdown
//         </Typography>
//         {breakdownData.map((item, index) => (
//           <Box
//             key={index}
//             sx={{
//               display: 'flex',
//               justifyContent: 'space-between',
//               alignItems: 'center',
//               py: 0.5,
//               px: 1,
//               borderRadius: 1,
//               cursor: 'pointer',
//               '&:hover': {
//                 backgroundColor: 'rgba(255,255,255,0.1)'
//               }
//             }}
//             onClick={() => handleBreakdownClick(item)}
//           >
//             <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//               <Box
//                 sx={{
//                   width: 8,
//                   height: 8,
//                   borderRadius: '50%',
//                   backgroundColor: item.color
//                 }}
//               />
//               <Typography variant="body2">{item.label}</Typography>
//             </Box>
//             <Typography variant="body2" fontWeight="bold">
//               {typeof item.value === 'number' && item.value > 1000 
//                 ? formatValue(item.value) 
//                 : item.value}
//             </Typography>
//           </Box>
//         ))}
//       </Box>
//     );

//     // Handle breakdown item click
//     const handleBreakdownClick = (breakdownItem) => {
//       const filterTitle = `${title} - ${breakdownItem.label}`;
//       setSelectedMetric(filterTitle);
//       setSelectedPincode(null);
//       setShowBottomLoader(true);
//       setLoadingProgress(0);
//       setShowTable(false);

//       const progressInterval = setInterval(() => {
//         setLoadingProgress((prev) => {
//           if (prev >= 100) {
//             clearInterval(progressInterval);
//             setTimeout(() => {
//               setShowBottomLoader(false);
//               setShowTable(true);
              
//               setTimeout(() => {
//                 tableRef.current?.scrollIntoView({ 
//                   behavior: 'smooth',
//                   block: 'start'
//                 });
//               }, 100);
//             }, 300);
//             return 100;
//           }
//           return prev + 2;
//         });
//       }, 40);
      
//       setTooltipOpen(false);
//     };

//     // Handle main card click
//     const handleCardClick = (e) => {
//       if (!tooltipOpen && !isTableLoading && !showBottomLoader) {
//         handleStatCardClick(title);
//       }
//     };

//     // Handle tooltip toggle
//     const handleTooltipToggle = (e) => {
//       e.stopPropagation();
//       setTooltipOpen(!tooltipOpen);
//     };

//     // Format value for display
//     const formatValue = (val) => {
//       if (typeof val === 'number') {
//         if (val >= 1000000) {
//           return `₹${(val / 1000000).toFixed(1)}M`;
//         } else if (val >= 1000) {
//           return `₹${(val / 1000).toFixed(1)}K`;
//         }
//         return `₹${val}`;
//       }
//       return val;
//     };

//     return (
//       <ClickAwayListener onClickAway={() => setTooltipOpen(false)}>
//         <Tooltip
//           title={breakdownData.length > 0 ? <TooltipContent /> : ''}
//           open={tooltipOpen && breakdownData.length > 0}
//           placement="bottom"
//           arrow
//           PopperProps={{
//             sx: {
//               '& .MuiTooltip-tooltip': {
//                 backgroundColor: 'rgba(0,0,0,0.9)',
//                 color: 'white',
//                 fontSize: '12px',
//                 borderRadius: 2,
//                 boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
//                 maxWidth: 'none'
//               },
//               '& .MuiTooltip-arrow': {
//                 color: 'rgba(0,0,0,0.9)'
//               }
//             }
//           }}
//         >
//           <Card
//             onClick={handleCardClick}
//             onMouseEnter={() => setIsHovered(true)}
//             onMouseLeave={() => setIsHovered(false)}
//             sx={{
//               height: '100%',
//               cursor: (isTableLoading || showBottomLoader) ? 'not-allowed' : 'pointer',
//               transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
//               transform: (isTableLoading || showBottomLoader) 
//                 ? 'translateY(0) scale(1)' 
//                 : isHovered ? 'translateY(-4px) scale(1.02)' : 'translateY(0) scale(1)',
//               boxShadow: (isTableLoading || showBottomLoader)
//                 ? '0 2px 8px rgba(0,0,0,0.05)'
//                 : isHovered 
//                   ? `0 12px 24px rgba(0,0,0,0.15), 0 0 0 1px ${color === 'primary' ? '#1976d2' : color === 'success' ? '#388e3c' : color === 'warning' ? '#f57c00' : '#d32f2f'}20`
//                   : '0 2px 8px rgba(0,0,0,0.1)',
//               border: `2px solid ${(isTableLoading || showBottomLoader) ? '#e0e0e0' : isHovered ? (color === 'primary' ? '#1976d2' : color === 'success' ? '#388e3c' : color === 'warning' ? '#f57c00' : '#d32f2f') + '40' : 'transparent'}`,
//               background: (isTableLoading || showBottomLoader) 
//                 ? 'linear-gradient(135deg, #f5f5f5 0%, #e8e8e8 100%)'
//                 : 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
//               opacity: (isTableLoading || showBottomLoader) ? 0.6 : 1,
//               position: 'relative',
//               overflow: 'visible',
//               pointerEvents: (isTableLoading || showBottomLoader) ? 'none' : 'auto'
//             }}
//           >
//             <CardContent sx={{ p: 3, pb: '24px !important' }}>
//               <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', mb: 2 }}>
//                 <Box sx={{ flex: 1 }}>
//                   <Typography 
//                     variant="body2" 
//                     color="text.secondary" 
//                     sx={{ 
//                       mb: 1, 
//                       fontWeight: 500,
//                       fontSize: '0.875rem'
//                     }}
//                   >
//                     {title}
//                   </Typography>
//                   <Typography 
//                     variant="h5" 
//                     fontWeight="bold" 
//                     sx={{ 
//                       color: 'text.primary',
//                       fontSize: '1.75rem',
//                       lineHeight: 1.2,
//                       mb: 0.5
//                     }}
//                   >
//                     {value}
//                   </Typography>
//                   {subtitle && (
//                     <Typography 
//                       variant="caption" 
//                       sx={{ 
//                         color: subtitle.includes('+') ? '#388e3c' : '#d32f2f',
//                         fontWeight: 600,
//                         fontSize: '0.75rem'
//                       }}
//                     >
//                       {subtitle}
//                     </Typography>
//                   )}
//                 </Box>
//                 <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 1 }}>
//                   <Box
//                     sx={{
//                       p: 1.5,
//                       borderRadius: 2,
//                       backgroundColor: color === 'primary' ? '#e3f2fd' : 
//                                      color === 'success' ? '#e8f5e8' : 
//                                      color === 'warning' ? '#fff8e1' : 
//                                      color === 'info' ? '#e1f5fe' :
//                                      color === 'secondary' ? '#fce4ec' : '#ffebee',
//                       display: 'flex',
//                       alignItems: 'center',
//                       justifyContent: 'center',
//                       transition: 'all 0.3s ease'
//                     }}
//                   >
//                     <Icon 
//                       sx={{ 
//                         fontSize: 28,
//                         color: color === 'primary' ? '#1976d2' : 
//                                color === 'success' ? '#388e3c' : 
//                                color === 'warning' ? '#f57c00' : 
//                                color === 'info' ? '#1976d2' :
//                                color === 'secondary' ? '#9c27b0' : '#d32f2f'
//                       }} 
//                     />
//                   </Box>
//                   {breakdownData.length > 0 && (
//                     <IconButton
//                       size="small"
//                       onClick={handleTooltipToggle}
//                       sx={{
//                         backgroundColor: tooltipOpen ? 'action.selected' : 'transparent',
//                         '&:hover': {
//                           backgroundColor: 'action.hover'
//                         },
//                         transition: 'all 0.2s ease'
//                       }}
//                     >
//                       <InfoOutlinedIcon fontSize="small" />
//                     </IconButton>
//                   )}
//                 </Box>
//               </Box>
//             </CardContent>
            
//             {/* Hover indicator */}
//             {isHovered && (
//               <Box
//                 sx={{
//                   position: 'absolute',
//                   bottom: 0,
//                   left: 0,
//                   right: 0,
//                   height: 3,
//                   borderRadius: '0 0 4px 4px'
//                 }}
//               />
//             )}
//           </Card>
//         </Tooltip>
//       </ClickAwayListener>
//     );
//   };

//   const PinCodeCard = ({ pincode, city, orders, value, growth }) => (
//     <Card 
//       onClick={() => handlePincodeClick(pincode, city)}
//       sx={{ 
//         height: '100%',
//         cursor: 'pointer',
//         transition: 'all 0.3s ease',
//         '&:hover': {
//           transform: 'translateY(-4px)',
//           boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
//         }
//       }}
//     >
//       <CardContent sx={{ p: 2 }}>
//         <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
//           <Box display="flex" alignItems="center" gap={1}>
//             <LocationOn color="primary" sx={{ fontSize: 20 }} />
//             <Typography variant="subtitle2" fontWeight="bold">
//               {city}
//             </Typography>
//           </Box>
//           <Chip 
//             label={growth} 
//             size="small" 
//             color={growth.includes('+') ? 'success' : 'error'}
//             variant="outlined"
//           />
//         </Box>
        
//         <Typography variant="caption" color="text.secondary" display="block" mb={1}>
//           Pin Code: {pincode}
//         </Typography>
        
//         <Grid container spacing={1}>
//           <Grid item xs={6}>
//             <Box textAlign="center" p={1} bgcolor="primary.light" borderRadius={1}>
//               <Typography variant="h6" fontWeight="bold" color="white">
//                 {orders}
//               </Typography>
//               <Typography variant="caption" color="white">
//                 Orders
//               </Typography>
//             </Box>
//           </Grid>
//           <Grid item xs={6}>
//             <Box textAlign="center" p={1} bgcolor="success.light" borderRadius={1}>
//               <Typography variant="h6" fontWeight="bold" color="white">
//                 ₹{(value / 1000).toFixed(0)}K
//               </Typography>
//               <Typography variant="caption" color="white">
//                 Value
//               </Typography>
//             </Box>
//           </Grid>
//         </Grid>
//       </CardContent>
//     </Card>
//   );

//   const ProductCard = ({ title, products, isWorst = false }) => (
//     <Card sx={{ 
//       height: '100%',
//       transition: 'all 0.3s ease',
//       '&:hover': {
//         transform: 'translateY(-2px)',
//         boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
//       }
//     }}>
//       <CardContent>
//         <Typography variant="subtitle2" gutterBottom fontWeight="600">
//           {title}
//         </Typography>
//         <Box sx={{ mt: 1 }}>
//           {products.map((product, index) => (
//             <Box key={index} sx={{ mb: 1.5 }}>
//               <Box display="flex" justifyContent="space-between" alignItems="center" mb={0.5}>
//                 <Typography variant="caption" sx={{ fontSize: '0.7rem' }}>
//                   {product.name}
//                 </Typography>
//                 <Typography variant="caption" color="text.secondary" fontWeight="500">
//                   {product.count ? `${product.count} units` : `${product.performance}%`}
//                 </Typography>
//               </Box>
//               <LinearProgress
//                 variant="determinate"
//                 value={product.performance}
//                 sx={{
//                   height: 6,
//                   borderRadius: 3,
//                   backgroundColor: '#f0f0f0',
//                   '& .MuiLinearProgress-bar': {
//                     backgroundColor: isWorst ? '#f44336' : '#4caf50',
//                     borderRadius: 3,
//                     transition: 'all 0.3s ease',
//                   }
//                 }}
//               />
//             </Box>
//           ))}
//         </Box>
//       </CardContent>
//     </Card>
//   );

//   const DeliveryStatusCard = ({ title, items }) => (
//     <Card sx={{ 
//       height: '100%',
//       transition: 'all 0.3s ease',
//       '&:hover': {
//         transform: 'translateY(-2px)',
//         boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
//       }
//     }}>
//       <CardContent>
//         <Typography variant="subtitle2" gutterBottom fontWeight="600">
//           {title}
//         </Typography>
//         <Box sx={{ mt: 1 }}>
//           {items.map((item, index) => (
//             <Box key={index} sx={{ mb: 1.5 }}>
//               <Box display="flex" justifyContent="space-between" alignItems="center" mb={0.5}>
//                 <Typography 
//                   variant="caption" 
//                   sx={{ 
//                     fontSize: '0.7rem',
//                     fontWeight: item.isBold ? 'bold' : 'normal',
//                     color: item.isBold ? '#333' : 'text.primary',
//                     cursor: !item.isBold ? 'pointer' : 'default',
//                     transition: 'all 0.2s ease',
//                     '&:hover': {
//                       textDecoration: !item.isBold ? 'underline' : 'none',
//                       color: !item.isBold ? item.color : '#333'
//                     }
//                   }}
//                   onClick={() => !item.isBold && handleDeliveryStatusClick(item.name)}
//                 >
//                   {item.name}
//                 </Typography>
//                 <Typography 
//                   variant="caption" 
//                   sx={{ 
//                     fontSize: '0.7rem',
//                     fontWeight: item.isBold ? 'bold' : '500',
//                     color: item.color
//                   }}
//                 >
//                   {item.count}
//                 </Typography>
//               </Box>
//               {!item.isBold && (
//                 <Box sx={{ height: 4, backgroundColor: '#f0f0f0', borderRadius: 2, overflow: 'hidden' }}>
//                   <Box 
//                     sx={{ 
//                       height: '100%', 
//                       backgroundColor: item.color,
//                       width: `${(item.count / 658) * 100}%`,
//                       transition: 'width 0.3s ease'
//                     }} 
//                   />
//                 </Box>
//               )}
//               {item.isBold && index < items.length - 1 && (
//                 <Divider sx={{ mt: 1 }} />
//               )}
//             </Box>
//           ))}
//         </Box>
//       </CardContent>
//     </Card>
//   );

//   const CustomTooltip = ({ active, payload, label }) => {
//     if (active && payload && payload.length) {
//       return (
//         <Paper elevation={3} sx={{ p: 1, bgcolor: 'white' }}>
//           <Typography variant="caption" fontWeight="medium">
//             {label}
//           </Typography>
//           <Typography variant="caption" color="primary">
//             Sales: ₹{payload[0].value.toLocaleString()}
//           </Typography>
//         </Paper>
//       );
//     }
//     return null;
//   };

//   return (
//     <ThemeProvider theme={theme}>
//       <CssBaseline />
//       <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh', bgcolor: 'background.default' }}>
//         {/* Header */}
//         <AppBar position="static" elevation={0} sx={{ bgcolor: 'white', color: 'text.primary', height: 48 }}>
//           <Toolbar sx={{ minHeight: '48px !important', px: 2 }}>
//             <IconButton
//               edge="start"
//               color="inherit"
//               aria-label="menu"
//               onClick={() => setDrawerOpen(true)}
//               sx={{ mr: 2 }}
//               size="small"
//             >
//               <MenuIcon />
//             </IconButton>
            
//             {/* Role Selector */}
//             <Button
//               onClick={(e) => setRoleMenuAnchor(e.currentTarget)}
//               startIcon={roles[currentRole].icon}
//               sx={{
//                 mr: 2,
//                 bgcolor: roles[currentRole].color + '20',
//                 color: roles[currentRole].color,
//                 border: `1px solid ${roles[currentRole].color}40`,
//                 '&:hover': {
//                   bgcolor: roles[currentRole].color + '30',
//                 }
//               }}
//               size="small"
//             >
//               {roles[currentRole].name}
//             </Button>

//             <Typography variant="h6" component="div" sx={{ flexGrow: 1, fontSize: '1rem' }}>
//               E-commerce Dashboard
//             </Typography>
            
//             <IconButton
//               color="inherit"
//               onClick={handleSortClick}
//               sx={{ mr: 1 }}
//               size="small"
//             >
//               <Sort />
//             </IconButton>
//             <Button
//               variant="contained"
//               startIcon={<Download />}
//               size="small"
//               sx={{ fontSize: '0.75rem', px: 1 }}
//               onClick={() => {
//                 if (selectedMetric && tableData[selectedMetric]) {
//                   exportToExcel(tableData[selectedMetric], `${selectedMetric}_export`);
//                 } else {
//                   const dashboardData = getRoleBasedStats().map(stat => ({
//                     metric: stat.title,
//                     value: stat.numericValue,
//                     growth: stat.subtitle,
//                     role: roles[currentRole].name
//                   }));
//                   exportToExcel(dashboardData, `dashboard_${currentRole}_export`);
//                 }
//               }}
//             >
//               Export
//             </Button>
//           </Toolbar>
//         </AppBar>

//         {/* Role Selection Menu */}
//         <Menu
//           anchorEl={roleMenuAnchor}
//           open={Boolean(roleMenuAnchor)}
//           onClose={() => setRoleMenuAnchor(null)}
//         >
//           {Object.entries(roles).map(([key, role]) => (
//             <MenuItem 
//               key={key} 
//               onClick={() => handleRoleChange(key)}
//               selected={currentRole === key}
//             >
//               <ListItemIcon sx={{ color: role.color }}>
//                 {role.icon}
//               </ListItemIcon>
//               <ListItemText 
//                 primary={role.name}
//                 secondary={role.description}
//               />
//             </MenuItem>
//           ))}
//         </Menu>

//         {/* Sort Menu */}
//         <Menu
//           anchorEl={sortMenuAnchor}
//           open={Boolean(sortMenuAnchor)}
//           onClose={handleSortClose}
//         >
//           <MenuItem onClick={() => handleSortSelect('default')}>
//             <ListItemIcon>
//               <SwapVert />
//             </ListItemIcon>
//             Default Order
//           </MenuItem>
//           <MenuItem onClick={() => handleSortSelect('highest')}>
//             <ListItemIcon>
//               <TrendingUp />
//             </ListItemIcon>
//             Highest Values
//           </MenuItem>
//           <MenuItem onClick={() => handleSortSelect('lowest')}>
//             <ListItemIcon>
//               <TrendingDown />
//             </ListItemIcon>
//             Lowest Values
//           </MenuItem>
//           <MenuItem onClick={() => handleSortSelect('alphabetical')}>
//             <ListItemIcon>
//               <Sort />
//             </ListItemIcon>
//             Alphabetical
//           </MenuItem>
//         </Menu>

//         {/* Sidebar */}
//         <Drawer
//           anchor="left"
//           open={drawerOpen}
//           onClose={() => setDrawerOpen(false)}
//           sx={{
//             '& .MuiDrawer-paper': {
//               width: 240,
//               bgcolor: 'background.paper',
//             },
//           }}
//         >
//           <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', p: 1.5 }}>
//             <Typography variant="subtitle1" fontWeight="bold">
//               Navigation
//             </Typography>
//             <IconButton onClick={() => setDrawerOpen(false)} size="small">
//               <Close />
//             </IconButton>
//           </Box>
//           <Divider />
          
//           {/* Role indicator in sidebar */}
//           <Box sx={{ p: 2, bgcolor: roles[currentRole].color + '10' }}>
//             <Box display="flex" alignItems="center" gap={1}>
//               {roles[currentRole].icon}
//               <Box>
//                 <Typography variant="subtitle2" fontWeight="bold">
//                   {roles[currentRole].name}
//                 </Typography>
//                 <Typography variant="caption" color="text.secondary">
//                   {roles[currentRole].description}
//                 </Typography>
//               </Box>
//             </Box>
//           </Box>
//           <Divider />
          
//           <List dense>
//             {menuItems.map((item, index) => (
//               <ListItem 
//                 key={index} 
//                 button 
//                 sx={{ 
//                   mx: 1, 
//                   borderRadius: 1,
//                   bgcolor: item.active ? 'primary.main' : 'transparent',
//                   color: item.active ? 'white' : 'text.primary',
//                   '&:hover': {
//                     bgcolor: item.active ? 'primary.dark' : 'action.hover',
//                   }
//                 }}
//               >
//                 <ListItemIcon sx={{ color: 'inherit', minWidth: 32 }}>
//                   {item.icon}
//                 </ListItemIcon>
//                 <ListItemText primary={item.text} />
//               </ListItem>
//             ))}
//           </List>
//         </Drawer>
        

//         {/* Main Content */}
//         <Box sx={{ flexGrow: 1, overflow: 'auto', p: 1, position: 'relative' }}>
//           <Container maxWidth="xl" sx={{ py: 1 }}>
//             {/* Filters */}
//             <Paper elevation={1} sx={{ p: 1.5, mb: 2 }}>
//               <Grid container spacing={1.5}>
//                 <Grid item xs={12} sm={4}>
//                   <FormControl fullWidth size="small">
//                     <InputLabel sx={{ fontSize: '0.75rem' }}>Timeframe</InputLabel>
//                     <Select
//                       value={timeframe}
//                       onChange={(e) => handleTimeframeChange(e.target.value)}
//                       label="Timeframe"
//                       sx={{ fontSize: '0.75rem' }}
//                     >
//                       <MenuItem value="all-time">Today</MenuItem>
//                       <MenuItem value="last-year">Last Year</MenuItem>
//                       <MenuItem value="last-month">Last Month</MenuItem>
//                       <MenuItem value="last-week">Last Week</MenuItem>
//                       <MenuItem value="custom-range">Custom Range</MenuItem>
//                     </Select>
//                   </FormControl>
//                 </Grid>
//                 <Grid item xs={12} sm={4}>
//                     <FormControl fullWidth size="small">
//                     <InputLabel sx={{ fontSize: '0.75rem' }}>AREA</InputLabel>
//                     <Select
//                       value={region}
//                       onChange={(e) => setRegion(e.target.value)}
//                       label="Region"
//                       sx={{ fontSize: '0.75rem' }}
//                     >
//                       <MenuItem value="all">All AREA</MenuItem>
//                       <MenuItem value="north-america">Nagpur</MenuItem>
//                       <MenuItem value="europe">Raipur</MenuItem>
//                       <MenuItem value="asia">Durg</MenuItem>
//                     </Select>
//                   </FormControl>
                 
//                 </Grid>
//                 <Grid item xs={12} sm={4}>
//                  <FormControl fullWidth size="small">
//                     <InputLabel sx={{ fontSize: '0.75rem' }}>Branch</InputLabel>
//                     <Select
//                       value={category}
//                       onChange={(e) => setCategory(e.target.value)}
//                       label="Branch"
//                       sx={{ fontSize: '0.75rem' }}
//                     >
//                       <MenuItem value="all">All Branch</MenuItem>
//                       <MenuItem value="Ajni">Ajni</MenuItem>
//                       <MenuItem value="clothing">Nagour Shop</MenuItem>
//                       <MenuItem value="books">Manish Nagar</MenuItem>
//                       <MenuItem value="home">Ram Nagar</MenuItem>
//                     </Select>
//                   </FormControl>
//                 </Grid>
//               </Grid>

//               {/* Custom Date Range Section */}
//               {timeframe === 'custom-range' && (
//                 <Box sx={{ mt: 2 }}>
//                   <Grid container spacing={2} alignItems="flex-start">
//                     <Grid item xs={12} sm={4}>
//                       <LocalizationProvider dateAdapter={AdapterDayjs}>
//                         <DatePicker
//                           label="From Date"
//                           value={fromDate}
//                           onChange={handleFromDateChange}
//                           format="DD/MM/YYYY"
//                           shouldDisableDate={shouldDisableFromDate}
//                           slotProps={{
//                             textField: {
//                               size: 'small',
//                               fullWidth: true,
//                               sx: {
//                                 fontSize: '0.75rem',
//                                 backgroundColor: '#F1F8E9',
//                                 '& .MuiOutlinedInput-root': {
//                                   height: 40,
//                                   borderColor: dateRangeError && fromDate ? '#f44336' : undefined,
//                                   '&:hover': {
//                                     borderColor: dateRangeError && fromDate ? '#f44336' : undefined,
//                                   },
//                                   '&.Mui-focused': {
//                                     borderColor: dateRangeError && fromDate ? '#f44336' : undefined,
//                                   }
//                                 }
//                               },
//                             },
//                           }}
//                         />
//                       </LocalizationProvider>
//                     </Grid>
//                     <Grid item xs={12} sm={4}>
//                       <LocalizationProvider dateAdapter={AdapterDayjs}>
//                         <DatePicker
//                           label="To Date"
//                           value={toDate}
//                           onChange={handleToDateChange}
//                           format="DD/MM/YYYY"
//                           shouldDisableDate={shouldDisableToDate}
//                           slotProps={{
//                             textField: {
//                               size: 'small',
//                               fullWidth: true,
//                               sx: {
//                                 fontSize: '0.75rem',
//                                 backgroundColor: '#F1F8E9',
//                                 '& .MuiOutlinedInput-root': {
//                                   height: 40,
//                                   borderColor: dateRangeError && toDate ? '#f44336' : undefined,
//                                   '&:hover': {
//                                     borderColor: dateRangeError && toDate ? '#f44336' : undefined,
//                                   },
//                                   '&.Mui-focused': {
//                                     borderColor: dateRangeError && toDate ? '#f44336' : undefined,
//                                   }
//                                 }
//                               },
//                             },
//                           }}
//                         />
//                       </LocalizationProvider>
//                     </Grid>
//                     <Grid item xs={12} sm={4}>
//                       {dateRangeError && (
//                         <Alert severity="error" sx={{ fontSize: '0.75rem', py: 0.5 }}>
//                           {dateRangeError}
//                         </Alert>
//                       )}
//                       {!dateRangeError && fromDate && toDate && (
//                         <Alert severity="success" sx={{ fontSize: '0.75rem', py: 0.5 }}>
//                           Valid date range selected ({toDate.diff(fromDate, 'day')} days)
//                         </Alert>
//                       )}
//                     </Grid>
//                   </Grid>
//                 </Box>
//               )}
//             </Paper>

//             {/* Pin Code Cards - Only for Central Manager */}
//             {currentRole === 'central-manager' && (
//               <Paper elevation={1} sx={{ p: 2, mb: 2 }}>
//                 <Typography variant="h6" gutterBottom fontWeight="bold" color="primary">
//                   Top Pin Codes Performance (Click to view details)
//                 </Typography>
//                 <Grid container spacing={2}>
//                   {topPinCodes.map((pincode, index) => (
//                     <Grid item xs={12} sm={6} md={3} key={index}>
//                       <PinCodeCard {...pincode} />
//                     </Grid>
//                   ))}
//                 </Grid>
//               </Paper>
//             )}

//             {/* Layout with Chart on Left, Tables on Right */}
//             <Grid container spacing={2}>
//               {/* Left Side - Stats and Chart */}
//               <Grid item xs={12} md={8}>
//                 {/* Stats Cards */}
//                 <Grid container spacing={1} sx={{ mb: 2 }}>
//                   {getSortedStats().map((stat, index) => (
//                     <Grid item xs={6} sm={currentRole === 'shop-manager' ? 4 : 4} key={stat.title}>
//                       <StatCard
//                         title={stat.title}
//                         value={stat.value}
//                         subtitle={stat.subtitle}
//                         icon={stat.icon}
//                         color={stat.color}
//                         index={index}
//                       />
//                     </Grid>
//                   ))}
//                 </Grid>

//                 {/* Sales Chart */}
//                 <Card sx={{ 
//                   position: 'relative',
//                   transition: 'all 0.3s ease',
//                   '&:hover': {
//                     transform: 'translateY(-2px)',
//                     boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
//                   }
//                 }}>
//                   <CardContent>
//                     <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
//                       <Typography variant="subtitle2" fontWeight="600">
//                         Monthly Sales Activity (Click bars for details)
//                       </Typography>
//                       <Button
//                         size="small"
//                         startIcon={<FileDownload />}
//                         onClick={() => exportToExcel(salesData, 'monthly_sales_data')}
//                         variant="outlined"
//                       >
//                         Export Chart Data
//                       </Button>
//                     </Box>
//                     <Box sx={{ height: 300, mt: 1 }}>
//                       <ResponsiveContainer width="100%" height="100%">
//                         <BarChart data={salesData} onClick={handleChartClick}>
//                           <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
//                           <XAxis dataKey="month" fontSize={10} />
//                           <YAxis fontSize={10} />
//                           <Tooltip content={<CustomTooltip />} />
//                           <Bar 
//                             dataKey="sales" 
//                             fill="#1976d2" 
//                             radius={[2, 2, 0, 0]}
//                             style={{ cursor: 'pointer' }}
//                           />
//                         </BarChart>
//                       </ResponsiveContainer>
//                     </Box>
//                   </CardContent>
//                 </Card>
//               </Grid>

//               {/* Right Side - Tables */}
//               <Grid item xs={12} md={4}>
//                 <Grid container spacing={2}>
//                   <Grid item xs={12}>
//                     <ProductCard
//                       title="Product Sales Performance"
//                       products={worstProducts}
//                       isWorst={true}
//                     />
//                   </Grid>
//                   <Grid item xs={12}>
//                     <DeliveryStatusCard
//                       title="Delivery Status (Click items for details)"
//                       items={deliveryStatus}
//                     />
//                   </Grid>
//                 </Grid>
//               </Grid>
//             </Grid>

//             {/* Dynamic Table */}
//             {renderTable()}
//           </Container>

//           {/* Bottom Loading Bar */}
//           <Slide direction="up" in={showBottomLoader} timeout={500}>
//             <Box
//               sx={{
//                 position: 'fixed',
//                 bottom: 0,
//                 left: 0,
//                 right: 0,
//                 backgroundColor: 'rgba(255, 255, 255, 0.95)',
//                 backdropFilter: 'blur(10px)',
//                 borderTop: '1px solid rgba(0, 0, 0, 0.1)',
//                 p: 2,
//                 zIndex: 1000,
//                 boxShadow: '0 -4px 20px rgba(0, 0, 0, 0.1)',
//               }}
//             >
//               <Box display="flex" alignItems="center" justifyContent="center" mb={1}>
//                 <CircularProgress size={20} sx={{ mr: 1 }} />
//                 <Typography variant="body2" color="text.secondary">
//                   Loading detailed data...
//                 </Typography>
//               </Box>
//               <LinearProgress 
//                 variant="determinate" 
//                 value={loadingProgress} 
//                 sx={{
//                   height: 4,
//                   borderRadius: 2,
//                   backgroundColor: 'rgba(25, 118, 210, 0.1)',
//                   '& .MuiLinearProgress-bar': {
//                     borderRadius: 2,
//                     background: 'linear-gradient(90deg, #1976d2, #42a5f5)',
//                   }
//                 }}
//               />
//               <Typography 
//                 variant="caption" 
//                 color="text.secondary" 
//                 sx={{ display: 'block', textAlign: 'center', mt: 0.5 }}
//               >
//                 {loadingProgress}% complete
//               </Typography>
//             </Box>
//           </Slide>
//         </Box>
//       </Box>
//     </ThemeProvider>
//   );
// };

// export default HomeScreen;






























import React from 'react';
import Header from './Header'; // Import the Header component
import './HomeScreen.css'; // Import the CSS file
import { useLocation } from 'react-router-dom'; // Import useLocation


export const HomeScreen = () => {
  const location = useLocation();
  const { userId, userName } = location.state || {}; // Get user info from location state
console.log("------",userName);
console.log("------",userId);
  return (
    <>
    <div>
    <Header />
    </div>
    
    
    <div className="home-screen">
    </div>
    </>
    
  );
  
};

export default HomeScreen;






























// import React, {useState } from 'react';
// import {
//   Container,
//   Box,
//   Typography,
//   Grid,
//   TextField,
//   Autocomplete,
//   Radio,
//   RadioGroup,
//   FormControlLabel,
//   FormControl,
//   FormLabel,
//   Button,
//   FormHelperText,
//   Select,
//   InputLabel,
//   MenuItem,
//   Paper,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   IconButton,
//   Alert
// } from '@mui/material';
// import DeleteIcon from '@mui/icons-material/Delete';

// export const HomeScreen = () => {
//   // --- MOCK DATA ---
//   // Define data inside the component to ensure it's always available.
//   const horecaCustomers = [
//     { id: 1, label: 'The Grand Hotel' },
//     { id: 2, label: 'Coastal Cafe' },
//     { id: 3, label: 'Urban Eatery' },
//     { id: 4, label: 'Skyline Restaurant & Bar' },
//     { id: 5, label: 'The Corner Bistro' },
//   ];

//   const customerAreas = ['North Mumbai', 'South Mumbai', 'Central Suburbs', 'Western Suburbs'];
//   const creditTypeOptions = ['Temporary Credit', 'Cash', 'Credit'];
//   const discountOptions = ['5% Off', '10% Off', 'Festival Deal', 'No Discount'];
//   // --- END MOCK DATA ---

//   // State for form fields
//   const [customer, setCustomer] = useState(null);
//   const [area, setArea] = useState('');
//   const [creditType, setCreditType] = useState('');
//   const [additionalDiscount, setAdditionalDiscount] = useState('');
  
//   // State for staged entries in the table
//   const [tableData, setTableData] = useState([]);
  
//   // State for validation errors
//   const [errors, setErrors] = useState({});

//   const validateRow = () => {
//     const newErrors = {};
//     if (!customer) newErrors.customer = 'Customer is required.';
//     if (!area) newErrors.area = 'Area is required.';
//     if (!creditType) newErrors.creditType = 'Credit type is required.';
//     if (!additionalDiscount) newErrors.additionalDiscount = 'Discount is required.';
//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const resetForm = () => {
//       setCustomer(null);
//       setArea('');
//       setCreditType('');
//       setAdditionalDiscount('');
//       setErrors({});
//   };

//   const handleAddRow = () => {
//     if (validateRow()) {
//       const newRow = {
//         id: new Date().getTime(),
//         customer: customer,
//         area: area,
//         creditType: creditType,
//         additionalDiscount: additionalDiscount,
//       };
//       setTableData(prev => [...prev, newRow]);
//       resetForm();
//     }
//   };

//   const handleDeleteRow = (id) => {
//     setTableData(prev => prev.filter(row => row.id !== id));
//   };
  
//   const handleSubmitAll = () => {
//     if (tableData.length === 0) {
//       alert("There are no entries to submit.");
//       return;
//     }
//     console.log("Submitting All Entries:", tableData);
//     alert(`Successfully submitted ${tableData.length} entries! Check the console for details.`);
//     setTableData([]);
//   };

//   return (
//     <>
//       <Box sx={{ pb: '80px' /* Padding for footer */ }}>
//         <Container maxWidth="md">
//           {/* --- FORM SECTION --- */}
//           <Box
//             sx={{
//               mt: 3,
//               p: 2.5,
//               boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
//               borderRadius: 2,
//               backgroundColor: 'white',
//             }}
//           >
//             <Typography variant="h5" component="h1" gutterBottom align="center" fontWeight="bold">
//               Customer Mapping
//             </Typography>
//             <Grid container spacing={2} sx={{ mt: 1 }}>
//               <Grid item xs={12}>
//                 <Autocomplete size="small" options={horecaCustomers} getOptionLabel={(option) => option.label} value={customer} onChange={(e, val) => setCustomer(val)} renderInput={(params) => (<TextField {...params} label="HORECA Customer" variant="outlined" error={!!errors.customer} helperText={errors.customer} />)}/>
//               </Grid>
//               <Grid item xs={12}>
//                 <FormControl fullWidth error={!!errors.area} size="small">
//                   <InputLabel>Customer Area</InputLabel>
//                   <Select value={area} label="Customer Area" onChange={(e) => setArea(e.target.value)}>
//                     {customerAreas.map((opt) => (<MenuItem key={opt} value={opt}>{opt}</MenuItem>))}
//                   </Select>
//                   {errors.area && <FormHelperText>{errors.area}</FormHelperText>}
//                 </FormControl>
//               </Grid>
//               <Grid item xs={12} sm={6}>
//                 <FormControl component="fieldset" error={!!errors.creditType}>
//                   <FormLabel component="legend" sx={{fontSize: '0.8rem'}}>Credit Type</FormLabel>
//                   <RadioGroup row value={creditType} onChange={(e) => setCreditType(e.target.value)}>
//                     {creditTypeOptions.map(opt => (<FormControlLabel key={opt} value={opt} control={<Radio size="small"/>} label={<Typography variant="body2">{opt}</Typography>} />))}
//                   </RadioGroup>
//                   {errors.creditType && <FormHelperText>{errors.creditType}</FormHelperText>}
//                 </FormControl>
//               </Grid>
//               <Grid item xs={12} sm={6}>
//                 <FormControl fullWidth error={!!errors.additionalDiscount} size="small">
//                   <InputLabel>Additional Discount</InputLabel>
//                   <Select value={additionalDiscount} label="Additional Discount" onChange={(e) => setAdditionalDiscount(e.target.value)}>
//                     {discountOptions.map((opt) => (<MenuItem key={opt} value={opt}>{opt}</MenuItem>))}
//                   </Select>
//                   {errors.additionalDiscount && <FormHelperText>{errors.additionalDiscount}</FormHelperText>}
//                 </FormControl>
//               </Grid>
//               <Grid item xs={12}>
//                 <Button onClick={handleAddRow} fullWidth variant="contained" color="secondary" size="medium">
//                   Add to List
//                 </Button>
//               </Grid>
//             </Grid>
//           </Box>

//           {/* --- TABLE VIEW SECTION --- */}
//           {tableData.length > 0 ? (
//             <TableContainer component={Paper} sx={{ mt: 3, maxHeight: 400 }}>
//               <Table stickyHeader aria-label="compact-sticky-table">
//                 <TableHead>
//                   <TableRow>
//                     <TableCell>Customer</TableCell>
//                     <TableCell>Area</TableCell>
//                     <TableCell>Credit Type</TableCell>
//                     <TableCell>Discount</TableCell>
//                     <TableCell align="right">Actions</TableCell>
//                   </TableRow>
//                 </TableHead>
//                 <TableBody>
//                   {tableData.map((row) => (
//                     <TableRow hover key={row.id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
//                       <TableCell sx={{py: 1}}>{row.customer.label}</TableCell>
//                       <TableCell sx={{py: 1}}>{row.area}</TableCell>
//                       <TableCell sx={{py: 1}}>{row.creditType}</TableCell>
//                       <TableCell sx={{py: 1}}>{row.additionalDiscount}</TableCell>
//                       <TableCell align="right" sx={{py: 0.5}}>
//                         <IconButton onClick={() => handleDeleteRow(row.id)} color="error" size="small">
//                           <DeleteIcon fontSize="small" />
//                         </IconButton>
//                       </TableCell>
//                     </TableRow>
//                   ))}
//                 </TableBody>
//               </Table>
//             </TableContainer>
//           ) : (
//             <Alert severity="info" sx={{ mt: 3 }}>
//               List is empty. Fill the form and click "Add to List".
//             </Alert>
//           )}
//         </Container>
//       </Box>

//       {/* --- STICKY FOOTER --- */}
//       <Box component="footer" sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, py: 1.5, backgroundColor: 'background.paper', boxShadow: '0 -2px 10px rgba(0,0,0,0.1)', display: 'flex', justifyContent: 'center', zIndex: 1100 }}>
//         <Button onClick={handleSubmitAll} variant="contained" color="primary" size="medium" disabled={tableData.length === 0} sx={{ fontWeight: 'bold', px: 4 }}>
//           Submit All ({tableData.length})
//         </Button>
//       </Box>
//     </>
//   );
// };

// export default HomeScreen;


















// import React, { useState, useRef } from 'react';
// import * as XLSX from 'xlsx';
// import axios from 'axios';
// import {
//   Box,
//   Button,
//   Paper,
//   Typography,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Alert,
//   Chip,
//   LinearProgress,
//   Card,
//   CardContent,
//   Divider,
//   IconButton,
//   Tooltip,
//   Container,
//   Grid,
//   useMediaQuery,
//   useTheme,
//   Fab,
//   Backdrop,
//   CircularProgress
// } from '@mui/material';
// import {
//   CloudUpload,
//   Description,
//   Error,
//   CheckCircle,
//   Warning,
//   Refresh,
//   Download,
//   Upload,
//   Send
// } from '@mui/icons-material';
// import { styled } from '@mui/material/styles';

// const StyledPaper = styled(Paper)(({ theme }) => ({
//   padding: theme.spacing(1.5, 2),
//   margin: theme.spacing(0.5),
//   background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
//   borderRadius: '10px',
//   boxShadow: '0 5px 15px rgba(0,0,0,0.1)',
//   [theme.breakpoints.down('md')]: {
//     padding: theme.spacing(1),
//     margin: theme.spacing(0.25),
//     borderRadius: '8px',
//   },
//   [theme.breakpoints.down('sm')]: {
//     padding: theme.spacing(1),
//     margin: 0,
//     borderRadius: '6px',
//   },
// }));

// const UploadArea = styled(Box)(({ theme }) => ({
//   border: '2px dashed #1976d2',
//   borderRadius: '8px',
//   padding: theme.spacing(2),
//   textAlign: 'center',
//   backgroundColor: '#fafafa',
//   transition: 'all 0.3s ease',
//   cursor: 'pointer',
//   '&:hover': {
//     backgroundColor: '#f0f8ff',
//     borderColor: '#1565c0',
//     transform: 'translateY(-1px)',
//   },
//   '&.drag-over': {
//     backgroundColor: '#e3f2fd',
//     borderColor: '#0d47a1',
//   },
//   [theme.breakpoints.down('md')]: {
//     padding: theme.spacing(1.5),
//     borderWidth: '2px',
//   },
//   [theme.breakpoints.down('sm')]: {
//     padding: theme.spacing(1),
//     borderRadius: '6px',
//   },
// }));

// const ClassicButton = styled(Button)(({ theme }) => ({
//   background: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
//   border: 0,
//   borderRadius: '20px',
//   boxShadow: '0 2px 10px 2px rgba(33, 203, 243, .2)',
//   color: 'white',
//   height: 36,
//   padding: '0 20px',
//   fontSize: '14px',
//   fontWeight: 'bold',
//   textTransform: 'none',
//   transition: 'all 0.3s ease',
//   '&:hover': {
//     background: 'linear-gradient(45deg, #1976d2 30%, #1e88e5 90%)',
//     transform: 'translateY(-1px)',
//     boxShadow: '0 4px 15px 2px rgba(33, 203, 243, .3)',
//   },
//   [theme.breakpoints.down('sm')]: {
//     height: 32,
//     fontSize: '12px',
//     padding: '0 16px',
//   },
// }));

// const SubmitButton = styled(Button)(({ theme }) => ({
//   background: 'linear-gradient(45deg, #4caf50 30%, #8bc34a 90%)',
//   border: 0,
//   borderRadius: '20px',
//   boxShadow: '0 2px 10px 2px rgba(76, 175, 80, .2)',
//   color: 'white',
//   height: 36,
//   padding: '0 24px',
//   fontSize: '14px',
//   fontWeight: 'bold',
//   textTransform: 'none',
//   transition: 'all 0.3s ease',
//   '&:hover': {
//     background: 'linear-gradient(45deg, #388e3c 30%, #689f38 90%)',
//     transform: 'translateY(-1px)',
//     boxShadow: '0 4px 15px 2px rgba(76, 175, 80, .3)',
//   },
//   '&:disabled': {
//     background: 'linear-gradient(45deg, #bdbdbd 30%, #e0e0e0 90%)',
//     boxShadow: 'none',
//     transform: 'none',
//   },
//   [theme.breakpoints.down('sm')]: {
//     height: 32,
//     fontSize: '12px',
//     padding: '0 20px',
//   },
// }));

// const ErrorCell = styled(TableCell)(() => ({
//   backgroundColor: '#ffebee',
//   color: '#c62828',
//   fontWeight: 'bold',
//   border: '2px solid #ef5350',
//   position: 'relative',
//   '&::after': {
//     content: '""',
//     position: 'absolute',
//     right: '5px',
//     top: '50%',
//     transform: 'translateY(-50%)',
//     width: '6px',
//     height: '6px',
//     backgroundColor: '#d32f2f',
//     borderRadius: '50%',
//   }
// }));

// export const HomeScreen = () => {
//   const [file, setFile] = useState(null);
//   const [data, setData] = useState([]);
//   const [errors, setErrors] = useState({});
//   const [loading, setLoading] = useState(false);
//   const [uploading, setUploading] = useState(false);
//   const [uploadStats, setUploadStats] = useState({ total: 0, valid: 0, invalid: 0 });
//   const fileInputRef = useRef(null);
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
//   const isTablet = useMediaQuery(theme.breakpoints.down('md'));

//   const validateRow = (row, index) => {
//     const rowErrors = [];
    
//     // AreaID validation
//     if (row.areaid === undefined || row.areaid === null || row.areaid === '') {
//       rowErrors.push('AreaID cannot be empty');
//     } else if (typeof row.areaid === 'string' && /[a-zA-Z]/.test(row.areaid)) {
//       rowErrors.push('AreaID cannot contain letters');
//     }

//     // BatchNumber validation
//     if (row.batchnumber === undefined || row.batchnumber === null || row.batchnumber === '') {
//       rowErrors.push('BatchNumber cannot be empty');
//     }

//     // ItemCode validation
//     if (!row.itemcode || row.itemcode.toString().trim() === '') {
//       rowErrors.push('ItemCode cannot be empty');
//     }

//     // Price validation
//     if (row.price === undefined || row.price === null || row.price === '') {
//       rowErrors.push('Price cannot be empty');
//     } else if (row.price < 0) {
//       rowErrors.push('Price cannot be less than zero');
//     } else if (typeof row.price === 'string' && row.price.includes(',')) {
//       rowErrors.push('Price cannot contain commas - only decimal points allowed');
//     } else if (isNaN(parseFloat(row.price))) {
//       rowErrors.push('Price must be a valid number');
//     }

//     return rowErrors;
//   };

//   const handleFileUpload = (uploadedFile) => {
//     if (!uploadedFile) return;

//     setLoading(true);
//     setFile(uploadedFile);
    
//     const reader = new FileReader();
//     reader.onload = (e) => {
//       try {
//         const data = e.target.result;
//         const workbook = XLSX.read(data, { type: 'binary' });
//         const sheetName = workbook.SheetNames[0];
//         const worksheet = workbook.Sheets[sheetName];
//         const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
        
//         if (jsonData.length === 0) {
//           setData([]);
//           setErrors({});
//           setLoading(false);
//           return;
//         }

//         // Assume first row is headers
//         const headers = jsonData[0];
//         const rows = jsonData.slice(1);
        
//         const processedData = rows.map((row, index) => {
//           const obj = {};
//           headers.forEach((header, headerIndex) => {
//             obj[header.toLowerCase()] = row[headerIndex];
//           });
//           return { ...obj, rowIndex: index + 2 }; // +2 because Excel is 1-indexed and we skip header
//         });

//         // Validate data
//         const newErrors = {};
//         let validCount = 0;
//         let invalidCount = 0;

//         processedData.forEach((row, index) => {
//           const rowErrors = validateRow(row, index);
//           if (rowErrors.length > 0) {
//             newErrors[index] = rowErrors;
//             invalidCount++;
//           } else {
//             validCount++;
//           }
//         });

//         setData(processedData);
//         setErrors(newErrors);
//         setUploadStats({
//           total: processedData.length,
//           valid: validCount,
//           invalid: invalidCount
//         });
//       } catch (error) {
//         console.error('Error processing file:', error);
//         alert('Error reading the Excel file. Please ensure it\'s a valid .xlsx file.');
//       }
//       setLoading(false);
//     };
//     reader.readAsBinaryString(uploadedFile);
//   };

//   const handleDrop = (e) => {
//     e.preventDefault();
//     const droppedFile = e.dataTransfer.files[0];
//     if (droppedFile && (droppedFile.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || droppedFile.name.endsWith('.xlsx'))) {
//       handleFileUpload(droppedFile);
//     } else {
//       alert('Please upload a valid .xlsx file');
//     }
//   };

//   const handleDragOver = (e) => {
//     e.preventDefault();
//   };

//   const handleFileInputChange = (e) => {
//     const selectedFile = e.target.files[0];
//     if (selectedFile) {
//       handleFileUpload(selectedFile);
//     }
//   };

//   const clearData = () => {
//     setFile(null);
//     setData([]);
//     setErrors({});
//     setUploadStats({ total: 0, valid: 0, invalid: 0 });
//     if (fileInputRef.current) {
//       fileInputRef.current.value = '';
//     }
//   };

//   const getErrorsForRow = (rowIndex) => {
//     return errors[rowIndex] || [];
//   };

//   const hasError = (rowIndex) => {
//     return errors[rowIndex] && errors[rowIndex].length > 0;
//   };

//   const handleSubmit = async () => {
//     if (data.length === 0) {
//       alert('Please upload a file first');
//       return;
//     }

//     if (uploadStats.invalid > 0) {
//       if (!window.confirm(`There are ${uploadStats.invalid} invalid records. Do you want to upload only the valid records?`)) {
//         return;
//       }
//     }

//     setUploading(true);
//     try {
//       // Filter out invalid records
//       const validData = data.filter((row, index) => !hasError(index));
      
//       // Prepare data for API
//       const uploadData = {
//         data: validData.map(row => ({
//           AreaID: row.areaid,
//           BatchNumber: row.batchnumber,
//           ItemCode: row.itemcode,
//           Price: parseFloat(row.price)
//         })),
//         fileName: file.name,
//         totalRecords: data.length,
//         validRecords: validData.length,
//         invalidRecords: uploadStats.invalid
//       };

//       // Replace with your actual API endpoint
//       const response = await axios.post('/api/batch-rate-upload', uploadData, {
//         headers: {
//           'Content-Type': 'application/json',
//         },
//       });

//       if (response.status === 200) {
//         alert(`Successfully uploaded ${validData.length} records!`);
//         // Optionally clear the form after successful upload
//         // clearData();
//       }
//     } catch (error) {
//       console.error('Upload error:', error);
//       alert('Failed to upload data. Please try again.');
//     } finally {
//       setUploading(false);
//     }
//   };

//   return (
//     <Container maxWidth="xl" sx={{ py: 0.5, height: '100vh', overflow: 'auto' }}>
//       <StyledPaper elevation={6}>
//         <Box sx={{ mb: 1, textAlign: 'center' }}>
//           <Typography 
//             variant="h6" 
//             sx={{ 
//               fontWeight: 'bold', 
//               color: '#1565c0', 
//               mb: 0.5,
//               fontSize: '1.1rem'
//             }}
//           >
//             Master Rate Upload
//           </Typography>
//           <Typography 
//             variant="caption" 
//             color="textSecondary"
//             sx={{ fontSize: '0.75rem' }}
//           >
//             Upload Excel file to validate and import master rate data
//           </Typography>
//         </Box>

//         {/* Two-column layout for upload and summary */}
//         <Grid container spacing={1} sx={{ mb: 1 }}>
//           {/* Left side - Upload Section */}
//           <Grid item xs={12} sm={12} md={6}>
//             <Card sx={{ borderRadius: '8px', height: '100%' }}>
//               <CardContent sx={{ p: 1.5 }}>
//                 <Typography variant="body2" sx={{ fontSize: '0.8rem', fontWeight: 'bold', mb: 1, display: 'flex', alignItems: 'center' }}>
//                   <CloudUpload sx={{ mr: 0.5, fontSize: '1rem', color: '#1976d2' }} />
//                   Excel Upload
//                 </Typography>
//                 <UploadArea
//                   onDrop={handleDrop}
//                   onDragOver={handleDragOver}
//                   onClick={() => fileInputRef.current?.click()}
//                 >
//                   <input
//                     type="file"
//                     ref={fileInputRef}
//                     onChange={handleFileInputChange}
//                     accept=".xlsx"
//                     style={{ display: 'none' }}
//                   />
//                   <CloudUpload sx={{ 
//                     fontSize: 28, 
//                     color: '#1976d2', 
//                     mb: 0.5
//                   }} />
//                   <Typography 
//                     variant="caption" 
//                     sx={{ mb: 0.5, color: '#1976d2', fontSize: '0.75rem' }}
//                   >
//                     Drop file here or click
//                   </Typography>
//                   <Typography variant="caption" color="textSecondary" sx={{ fontSize: '0.65rem', display: 'block' }}>
//                     .xlsx files only
//                   </Typography>
//                   <Box sx={{ mt: 1 }}>
//                     <ClassicButton startIcon={<Description />} size="small">
//                       Browse
//                     </ClassicButton>
//                   </Box>
//                 </UploadArea>

//                 {file && (
//                   <Box sx={{ 
//                     mt: 1.5, 
//                     display: 'flex', 
//                     alignItems: 'center', 
//                     justifyContent: 'space-between',
//                     gap: 1
//                   }}>
//                     <Box sx={{ display: 'flex', alignItems: 'center', flex: 1 }}>
//                       <Description sx={{ mr: 0.5, color: '#4caf50', fontSize: '1rem' }} />
//                       <Typography variant="caption" sx={{ fontSize: '0.7rem' }}>
//                         <strong>{file.name}</strong><br/>({(file.size / 1024).toFixed(1)} KB)
//                       </Typography>
//                     </Box>
//                     <Tooltip title="Clear">
//                       <IconButton onClick={clearData} color="error" size="small">
//                         <Refresh fontSize="small" />
//                       </IconButton>
//                     </Tooltip>
//                   </Box>
//                 )}

//                 {loading && (
//                   <Box sx={{ mt: 1 }}>
//                     <LinearProgress sx={{ borderRadius: '2px', height: 4 }} />
//                     <Typography variant="caption" sx={{ mt: 0.5, textAlign: 'center', display: 'block', fontSize: '0.65rem' }}>
//                       Processing file...
//                     </Typography>
//                   </Box>
//                 )}
//               </CardContent>
//             </Card>
//           </Grid>

//           {/* Right side - Summary & Submit Section */}
//           <Grid item xs={12} sm={12} md={6}>
//             <Card sx={{ borderRadius: '8px', height: '100%' }}>
//               <CardContent sx={{ p: 1.5, height: '100%', display: 'flex', flexDirection: 'column' }}>
//                 <Typography variant="body2" sx={{ fontSize: '0.8rem', fontWeight: 'bold', mb: 1, display: 'flex', alignItems: 'center' }}>
//                   <CheckCircle sx={{ mr: 0.5, color: '#4caf50', fontSize: '1rem' }} />
//                   Validation Summary
//                 </Typography>
                
//                 {data.length > 0 ? (
//                   <>
//                     <Box sx={{ mb: 1.5, flex: 1 }}>
//                       <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mb: 1 }}>
//                         <Chip label={`Total: ${uploadStats.total}`} color="primary" size="small" sx={{ fontSize: '0.6rem', height: 18 }} />
//                         <Chip label={`Valid: ${uploadStats.valid}`} color="success" size="small" sx={{ fontSize: '0.6rem', height: 18 }} />
//                         <Chip label={`Invalid: ${uploadStats.invalid}`} color="error" size="small" sx={{ fontSize: '0.6rem', height: 18 }} />
//                       </Box>
//                       {uploadStats.invalid > 0 && (
//                         <Typography 
//                           variant="caption" 
//                           color="warning.main" 
//                           sx={{ fontSize: '0.6rem', display: 'block' }}
//                         >
//                           {uploadStats.invalid} invalid records will be skipped
//                         </Typography>
//                       )}
//                     </Box>
                    
//                     <Box sx={{ mt: 'auto' }}>
//                       <SubmitButton
//                         onClick={handleSubmit}
//                         disabled={loading || uploading || uploadStats.valid === 0}
//                         startIcon={uploading ? <CircularProgress size={14} /> : <Upload />}
//                         size="small"
//                         fullWidth
//                       >
//                         {uploading ? 'Uploading...' : `Upload ${uploadStats.valid} Records`}
//                       </SubmitButton>
//                     </Box>
//                   </>
//                 ) : (
//                   <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center' }}>
//                     <Typography variant="caption" color="textSecondary" sx={{ fontSize: '0.65rem' }}>
//                       Upload a file to see validation summary and upload options
//                     </Typography>
//                   </Box>
//                 )}
//               </CardContent>
//             </Card>
//           </Grid>
//         </Grid>

//         {/* Table Section - Below both upload and summary */}
//         {data.length > 0 && (
//           <Card sx={{ borderRadius: '8px', overflow: 'hidden' }}>
//             <CardContent sx={{ p: 0 }}>
//               <Box sx={{ p: 1, backgroundColor: '#f5f5f5' }}>
//                 <Typography 
//                   variant="body2" 
//                   sx={{ display: 'flex', alignItems: 'center', fontSize: '0.8rem', fontWeight: 'bold' }}
//                 >
//                   <Description sx={{ mr: 0.5, fontSize: '1rem' }} />
//                   Data Preview & Validation Results
//                 </Typography>
//               </Box>
//               <Divider />
//               <TableContainer sx={{ 
//                 maxHeight: 300,
//                 '& .MuiTable-root': {
//                   minWidth: 600
//                 }
//               }}>
//                   <Table stickyHeader>
//                     <TableHead>
//                       <TableRow sx={{ backgroundColor: '#1976d2' }}>
//                         <TableCell sx={{ 
//                           fontWeight: 'bold', 
//                           color: 'white', 
//                           backgroundColor: '#1976d2',
//                           fontSize: '0.65rem',
//                           minWidth: 50,
//                           padding: '6px 8px'
//                         }}>
//                           Line
//                         </TableCell>
//                         <TableCell sx={{ 
//                           fontWeight: 'bold', 
//                           color: 'white', 
//                           backgroundColor: '#1976d2',
//                           fontSize: '0.65rem',
//                           minWidth: 60,
//                           padding: '6px 8px'
//                         }}>
//                           AreaID
//                         </TableCell>
//                         <TableCell sx={{ 
//                           fontWeight: 'bold', 
//                           color: 'white', 
//                           backgroundColor: '#1976d2',
//                           fontSize: '0.65rem',
//                           minWidth: 80,
//                           padding: '6px 8px'
//                         }}>
//                           Batch#
//                         </TableCell>
//                         <TableCell sx={{ 
//                           fontWeight: 'bold', 
//                           color: 'white', 
//                           backgroundColor: '#1976d2',
//                           fontSize: '0.65rem',
//                           minWidth: 80,
//                           padding: '6px 8px'
//                         }}>
//                           ItemCode
//                         </TableCell>
//                         <TableCell sx={{ 
//                           fontWeight: 'bold', 
//                           color: 'white', 
//                           backgroundColor: '#1976d2',
//                           fontSize: '0.65rem',
//                           minWidth: 60,
//                           padding: '6px 8px'
//                         }}>
//                           Price
//                         </TableCell>
//                         <TableCell sx={{ 
//                           fontWeight: 'bold', 
//                           color: 'white', 
//                           backgroundColor: '#1976d2',
//                           fontSize: '0.65rem',
//                           minWidth: 60,
//                           padding: '6px 8px'
//                         }}>
//                           Status
//                         </TableCell>
//                         <TableCell sx={{ 
//                           fontWeight: 'bold', 
//                           color: 'white', 
//                           backgroundColor: '#1976d2',
//                           fontSize: '0.65rem',
//                           minWidth: 150,
//                           padding: '6px 8px'
//                         }}>
//                           Errors
//                         </TableCell>
//                       </TableRow>
//                     </TableHead>
//                     <TableBody>
//                       {data.map((row, index) => (
//                         <TableRow
//                           key={index}
//                           sx={{
//                             backgroundColor: hasError(index) ? '#fff3e0' : index % 2 === 0 ? '#fafafa' : 'white',
//                             '&:hover': {
//                               backgroundColor: hasError(index) ? '#ffecb3' : '#f5f5f5',
//                             },
//                           }}
//                         >
//                           <TableCell sx={{ 
//                             fontWeight: 'bold',
//                             fontSize: '0.65rem',
//                             padding: '4px 8px'
//                           }}>
//                             {row.rowIndex}
//                           </TableCell>
//                           <TableCell
//                             sx={{
//                               ...(row.areaid === undefined || row.areaid === null || row.areaid === '' || 
//                                   (typeof row.areaid === 'string' && /[a-zA-Z]/.test(row.areaid))) ? 
//                                 { backgroundColor: '#ffebee', color: '#c62828', fontWeight: 'bold' } : {},
//                               fontSize: '0.65rem',
//                               padding: '4px 8px'
//                             }}
//                           >
//                             {row.areaid !== undefined && row.areaid !== null && row.areaid !== '' ? row.areaid : <em>Empty</em>}
//                           </TableCell>
//                           <TableCell
//                             sx={{
//                               ...(row.batchnumber === undefined || row.batchnumber === null || row.batchnumber === '') ?
//                                 { backgroundColor: '#ffebee', color: '#c62828', fontWeight: 'bold' } : {},
//                               fontSize: '0.65rem',
//                               padding: '4px 8px'
//                             }}
//                           >
//                             {row.batchnumber !== undefined && row.batchnumber !== null && row.batchnumber !== '' ? row.batchnumber : <em>Empty</em>}
//                           </TableCell>
//                           <TableCell
//                             sx={{
//                               ...(!row.itemcode || row.itemcode.toString().trim() === '') ? 
//                                 { backgroundColor: '#ffebee', color: '#c62828', fontWeight: 'bold' } : {},
//                               fontSize: '0.65rem',
//                               padding: '4px 8px'
//                             }}
//                           >
//                             {row.itemcode || <em>Empty</em>}
//                           </TableCell>
//                           <TableCell
//                             sx={{
//                               ...(row.price === undefined || row.price === null || row.price === '' || 
//                                   row.price < 0 || 
//                                   (typeof row.price === 'string' && row.price.includes(',')) ||
//                                   isNaN(parseFloat(row.price))) ?
//                                 { backgroundColor: '#ffebee', color: '#c62828', fontWeight: 'bold' } : {},
//                               fontSize: '0.65rem',
//                               padding: '4px 8px'
//                             }}
//                           >
//                             {row.price !== undefined && row.price !== null && row.price !== '' ? row.price : <em>Empty</em>}
//                           </TableCell>
//                           <TableCell sx={{ fontSize: '0.65rem', padding: '4px 8px' }}>
//                             {hasError(index) ? (
//                               <Chip
//                                 label="✗"
//                                 color="error"
//                                 size="small"
//                                 sx={{ fontSize: '0.6rem', height: 16, minWidth: 20 }}
//                               />
//                             ) : (
//                               <Chip
//                                 label="✓"
//                                 color="success"
//                                 size="small"
//                                 sx={{ fontSize: '0.6rem', height: 16, minWidth: 20 }}
//                               />
//                             )}
//                           </TableCell>
//                           <TableCell sx={{ 
//                             maxWidth: 150,
//                             fontSize: '0.6rem',
//                             padding: '4px 8px'
//                           }}>
//                             {hasError(index) && (
//                               <Box>
//                                 {getErrorsForRow(index).map((error, errorIndex) => (
//                                   <Typography 
//                                     key={errorIndex}
//                                     variant="caption"
//                                     sx={{ 
//                                       display: 'block',
//                                       color: 'error.main',
//                                       fontSize: '0.55rem',
//                                       lineHeight: 1.2,
//                                       mb: 0.25
//                                     }}
//                                   >
//                                     • {error}
//                                   </Typography>
//                                 ))}
//                               </Box>
//                             )}
//                           </TableCell>
//                         </TableRow>
//                       ))}
//                     </TableBody>
//                   </Table>
//               </TableContainer>
//             </CardContent>
//           </Card>
//         )}

//         {/* Empty state - shows when no file is uploaded */}
//         {!file && !loading && (
//           <Card sx={{ 
//             textAlign: 'center', 
//             py: 2, 
//             borderRadius: '8px',
//             mt: 1
//           }}>
//             <CardContent sx={{ py: '8px !important' }}>
//               <Description sx={{ 
//                 fontSize: 28, 
//                 color: '#bdbdbd', 
//                 mb: 0.5 
//               }} />
//               <Typography 
//                 variant="caption" 
//                 color="textSecondary"
//                 sx={{ fontSize: '0.7rem' }}
//               >
//                 Upload an Excel file to see data preview and validation results
//               </Typography>
//             </CardContent>
//           </Card>
//         )}
        
//         <Backdrop
//           sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
//           open={uploading}
//         >
//           <Box sx={{ textAlign: 'center' }}>
//             <CircularProgress color="inherit" size={40} />
//             <Typography variant="body1" sx={{ mt: 1.5, fontSize: '0.9rem' }}>
//               Uploading data...
//             </Typography>
//             <Typography variant="body2" sx={{ mt: 0.5, fontSize: '0.75rem' }}>
//               Please wait
//             </Typography>
//           </Box>
//         </Backdrop>
//       </StyledPaper>
//     </Container>
//   );
// };

// export default HomeScreen;